"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.000000
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BluetoothRoutesApiAxiosParamCreator = exports.AdminsFirmwareVersionsFirmwareTypeVersionOptionsFirmwareTypeEnum = exports.AdminsFirmwareS3OptionsFirmwareTypeOptionsFirmwareTypeEnum = exports.AdminSearchDevicesPaginatedSearchTypeEnum = exports.AdminListFirmwareS3OptionsFirmwareTypeEnum = exports.AdminGetFirmwareFirmwareTypeEnum = exports.AdminDeleteFirmwareFirmwareTypeEnum = exports.AdminsApi = exports.AdminsApiFactory = exports.AdminsApiFp = exports.AdminsApiAxiosParamCreator = exports.UpdateFleetCurrentLimitInputCurrentLimitEnum = exports.ResponsesUserProfileAccountTypeEnum = exports.ResponsesJobStatusResponseDataJobStatusEnum = exports.ResponsesFMSUserUserTypeEnum = exports.ResponsesFMSUserUserAccessTypeEnum = exports.ResponsesFMSUserEnergyUnitEnum = exports.ResponsesFMSStatusCheckJobPageEntryStatusEnum = exports.ResponsesFMSStatusCheckJobStatusEnum = exports.ResponsesFMSReportStatusResponseDataStatusEnum = exports.ResponsesFMSFleetUnitStatusResultEnum = exports.ResponsesFMSFleetScheduleEventEventTypeEnum = exports.ResponsesFMSFleetScheduleEventDaysOfWeekEnum = exports.ResponsesFMSFleetCurrentLimitResponseDataCurrentLimitEnum = exports.ResponsesFMSFleetWeatherWidgetProviderEnum = exports.ResponsesFMSCustomerUserViewUserAccessTypeEnum = exports.ResponsesFMSCustomerUserAdminViewUserAccessTypeEnum = exports.ResponsesFMSCustomerAdminViewStatusEnum = exports.ResponsesFMSCustomerStatusEnum = exports.ResponsesFMSAlertPageItemSeverityEnum = exports.ResponsesDeviceOtaStatusCheckResponseDataStatusEnum = exports.ResponsesAdminRoleRoleEnum = exports.ResponsesAdminGetDataStreamingShadowResponseDataReportedDataStreamingEnum = exports.ResponsesAdminGetDataStreamingShadowResponseDataDesiredDataStreamingEnum = exports.ResponsesAdminGetCurrentLimitShadowResponseDataReportedCurrentLimitEnum = exports.ResponsesAdminGetCurrentLimitShadowResponseDataDesiredCurrentLimitEnum = exports.ResponsesAdminCreateFleetManagementAdministratorResponseDataResultEnum = exports.ResponsesAdminAppFirmwareVersionCompatibilityResponseDataAppPlatformEnum = exports.ResponsesAdminAppFirmwareVersionCompatibilityListEntryAppPlatformEnum = exports.RequestsFMSFleetScheduleEventInputEventTypeEnum = exports.RequestsFMSFleetScheduleEventInputDaysOfWeekEnum = exports.RequestsDeviceSearchSearchTypeEnum = exports.RequestsAdminRoleRoleEnum = exports.ModelsFMSAlertDisplayItemSeverityEnum = exports.HandleAnalyticsMessageInputChannelEnum = exports.CreateFleetCSVReportInputReportKindEnum = exports.CreateFleetCSVReportInputFieldsEnum = exports.AdminUpdateDataStreamingShadowInputDataStreamingEnum = exports.AdminUpdateCurrentLimitInputCurrentLimitEnum = exports.AdminCreateFirmwareInputFirmwareTypeEnum = void 0;
exports.VersionApi = exports.VersionApiFactory = exports.VersionApiFp = exports.VersionApiAxiosParamCreator = exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = exports.ThingGroupRoutesApi = exports.ThingGroupRoutesApiFactory = exports.ThingGroupRoutesApiFp = exports.ThingGroupRoutesApiAxiosParamCreator = exports.OptionsApi = exports.OptionsApiFactory = exports.OptionsApiFp = exports.OptionsApiAxiosParamCreator = exports.IOTEventRoutesApi = exports.IOTEventRoutesApiFactory = exports.IOTEventRoutesApiFp = exports.IOTEventRoutesApiAxiosParamCreator = exports.FetchPageOfFleetTopUsersTimePeriodEnum = exports.FleetManagementSystemApi = exports.FleetManagementSystemApiFactory = exports.FleetManagementSystemApiFp = exports.FleetManagementSystemApiAxiosParamCreator = exports.DevicesApi = exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.BluetoothRoutesApi = exports.BluetoothRoutesApiFactory = exports.BluetoothRoutesApiFp = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.AdminCreateFirmwareInputFirmwareTypeEnum = {
    DenaliDefault: 'denali_default',
    FlagshipDefault: 'flagship_default',
    Custom: 'custom',
};
exports.AdminUpdateCurrentLimitInputCurrentLimitEnum = {
    SevenPointFiveAmp: 'SEVEN_POINT_FIVE_AMP',
    TwelveAmp: 'TWELVE_AMP',
};
exports.AdminUpdateDataStreamingShadowInputDataStreamingEnum = {
    On: 'ON',
    Off: 'OFF',
};
exports.CreateFleetCSVReportInputFieldsEnum = {
    ConnectionStatus: 'CONNECTION_STATUS',
    PowerStatus: 'POWER_STATUS',
    Mode: 'MODE',
    Setpoint: 'SETPOINT',
    IndoorTemp: 'INDOOR_TEMP',
    OutdoorTemp: 'OUTDOOR_TEMP',
    EnergyConsumption: 'ENERGY_CONSUMPTION',
    Cost: 'COST',
};
exports.CreateFleetCSVReportInputReportKindEnum = {
    Alerts: 'ALERTS',
    Data: 'DATA',
};
exports.HandleAnalyticsMessageInputChannelEnum = {
    WifiProvisioning: 'wifi_provisioning',
    UnprovisionedDevice: 'unprovisioned_device',
    AppLogs: 'app_logs',
    MqttErrors: 'mqtt_errors',
};
exports.ModelsFMSAlertDisplayItemSeverityEnum = {
    Critical: 'critical',
    Warning: 'warning',
    Maintenance: 'maintenance',
    Resolved: 'resolved',
};
exports.RequestsAdminRoleRoleEnum = {
    FirmwareManager: 'FirmwareManager',
    FirmwareReader: 'FirmwareReader',
    ProductManager: 'ProductManager',
};
exports.RequestsDeviceSearchSearchTypeEnum = {
    IdbMacId: 'idbMacId',
    SimSn: 'simSn',
    Email: 'email',
    Name: 'name',
    ThingName: 'thingName',
    DeviceGroup: 'deviceGroup',
};
exports.RequestsFMSFleetScheduleEventInputDaysOfWeekEnum = {
    Sunday: 'SUNDAY',
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
};
exports.RequestsFMSFleetScheduleEventInputEventTypeEnum = {
    Off: 'OFF',
    Cool: 'COOL',
    Heat: 'HEAT',
    HeatAndCool: 'HEAT_AND_COOL',
    FanOnly: 'FAN_ONLY',
    Dry: 'DRY',
};
exports.ResponsesAdminAppFirmwareVersionCompatibilityListEntryAppPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
};
exports.ResponsesAdminAppFirmwareVersionCompatibilityResponseDataAppPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
};
exports.ResponsesAdminCreateFleetManagementAdministratorResponseDataResultEnum = {
    Created: 'created',
    Invited: 'invited',
};
exports.ResponsesAdminGetCurrentLimitShadowResponseDataDesiredCurrentLimitEnum = {
    SevenPointFiveAmp: 'SEVEN_POINT_FIVE_AMP',
    TwelveAmp: 'TWELVE_AMP',
};
exports.ResponsesAdminGetCurrentLimitShadowResponseDataReportedCurrentLimitEnum = {
    SevenPointFiveAmp: 'SEVEN_POINT_FIVE_AMP',
    TwelveAmp: 'TWELVE_AMP',
};
exports.ResponsesAdminGetDataStreamingShadowResponseDataDesiredDataStreamingEnum = {
    On: 'ON',
    Off: 'OFF',
};
exports.ResponsesAdminGetDataStreamingShadowResponseDataReportedDataStreamingEnum = {
    On: 'ON',
    Off: 'OFF',
};
exports.ResponsesAdminRoleRoleEnum = {
    Administrator: 'Administrator',
    FirmwareManager: 'FirmwareManager',
    FirmwareReader: 'FirmwareReader',
    ProductManager: 'ProductManager',
};
exports.ResponsesDeviceOtaStatusCheckResponseDataStatusEnum = {
    NoChangeRequired: 'no_change_required',
    Processing: 'processing',
    Queued: 'queued',
    Failed: 'failed',
    Unknown: 'unknown',
};
exports.ResponsesFMSAlertPageItemSeverityEnum = {
    Critical: 'critical',
    Warning: 'warning',
    Maintenance: 'maintenance',
    Resolved: 'resolved',
};
exports.ResponsesFMSCustomerStatusEnum = {
    Inactive: 'INACTIVE',
    OnTrial: 'ON_TRIAL',
    Paid: 'PAID',
};
exports.ResponsesFMSCustomerAdminViewStatusEnum = {
    Inactive: 'INACTIVE',
    OnTrial: 'ON_TRIAL',
    Paid: 'PAID',
};
exports.ResponsesFMSCustomerUserAdminViewUserAccessTypeEnum = {
    FullAccess: 'FULL_ACCESS',
    ReadWrite: 'READ_WRITE',
    ReadOnly: 'READ_ONLY',
    Support: 'SUPPORT',
};
exports.ResponsesFMSCustomerUserViewUserAccessTypeEnum = {
    FullAccess: 'FULL_ACCESS',
    ReadWrite: 'READ_WRITE',
    ReadOnly: 'READ_ONLY',
    Support: 'SUPPORT',
};
exports.ResponsesFMSFleetWeatherWidgetProviderEnum = {
    WeatherWidgetDotOrg: 'WEATHER_WIDGET_DOT_ORG',
    OpenWeatherMap: 'OPEN_WEATHER_MAP',
};
exports.ResponsesFMSFleetCurrentLimitResponseDataCurrentLimitEnum = {
    SevenPointFiveAmp: 'SEVEN_POINT_FIVE_AMP',
    TwelveAmp: 'TWELVE_AMP',
};
exports.ResponsesFMSFleetScheduleEventDaysOfWeekEnum = {
    Sunday: 'SUNDAY',
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
};
exports.ResponsesFMSFleetScheduleEventEventTypeEnum = {
    Off: 'OFF',
    Cool: 'COOL',
    Heat: 'HEAT',
    HeatAndCool: 'HEAT_AND_COOL',
    FanOnly: 'FAN_ONLY',
    Dry: 'DRY',
};
exports.ResponsesFMSFleetUnitStatusResultEnum = {
    Success: 'success',
    Failed: 'failed',
};
exports.ResponsesFMSReportStatusResponseDataStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Success: 'success',
    Failed: 'failed',
};
exports.ResponsesFMSStatusCheckJobStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Success: 'success',
    Failed: 'failed',
};
exports.ResponsesFMSStatusCheckJobPageEntryStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Success: 'success',
    Failed: 'failed',
};
exports.ResponsesFMSUserEnergyUnitEnum = {
    Kwh: 'KWH',
    Btu: 'BTU',
};
exports.ResponsesFMSUserUserAccessTypeEnum = {
    FullAccess: 'FULL_ACCESS',
    ReadWrite: 'READ_WRITE',
    ReadOnly: 'READ_ONLY',
    Support: 'SUPPORT',
};
exports.ResponsesFMSUserUserTypeEnum = {
    GradientAdmin: 'GradientAdmin',
    Customer: 'Customer',
};
exports.ResponsesJobStatusResponseDataJobStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Success: 'success',
    Failed: 'failed',
};
exports.ResponsesUserProfileAccountTypeEnum = {
    Resident: 'Resident',
    BuildingManager: 'BuildingManager',
};
exports.UpdateFleetCurrentLimitInputCurrentLimitEnum = {
    SevenPointFiveAmp: 'SEVEN_POINT_FIVE_AMP',
    TwelveAmp: 'TWELVE_AMP',
};
/**
 * AdminsApi - axios parameter creator
 */
var AdminsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AdminAddDeviceSearchesToCustomFirmwareInput} [adminAddDeviceSearchesToCustomFirmwareInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddDeviceSearchesToCustomFirmware: function (adminAddDeviceSearchesToCustomFirmwareInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/custom-firmware-devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminAddDeviceSearchesToCustomFirmwareInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminAddUserToDeviceInput} [adminAddUserToDeviceInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddUserToDevice: function (deviceUnid, adminAddUserToDeviceInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminAddUserToDevice', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/users"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminAddUserToDeviceInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminCreateAdminInput} [adminCreateAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAdmin: function (adminCreateAdminInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateAdminInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminCreateAppFirmwareVersionCompatibilityInput} [adminCreateAppFirmwareVersionCompatibilityInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAppFirmwareVersionCompatibility: function (adminCreateAppFirmwareVersionCompatibilityInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/app-firmware-version-compatibility";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateAppFirmwareVersionCompatibilityInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminCreateDeviceGroupInput} [adminCreateDeviceGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateDeviceGroup: function (adminCreateDeviceGroupInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/device-groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateDeviceGroupInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminCreateFeatureFlagInput} [adminCreateFeatureFlagInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFeatureFlag: function (adminCreateFeatureFlagInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/feature-flags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateFeatureFlagInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminCreateFirmwareInput} [adminCreateFirmwareInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFirmware: function (adminCreateFirmwareInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/firmware-versions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateFirmwareInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminCreateOrInviteFleetManagementAdministratorInput} [adminCreateOrInviteFleetManagementAdministratorInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrInviteFleetManagementAdministrator: function (adminCreateOrInviteFleetManagementAdministratorInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/fleet-management-administrators";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateOrInviteFleetManagementAdministratorInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAdmin: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminDeleteAdmin', 'unid', unid);
                    localVarPath = "/admins/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAppFirmwareVersionCompatibility: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminDeleteAppFirmwareVersionCompatibility', 'unid', unid);
                    localVarPath = "/admins/app-firmware-version-compatibility/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDeviceGroup: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminDeleteDeviceGroup', 'unid', unid);
                    localVarPath = "/admins/device-groups/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFeatureFlag: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminDeleteFeatureFlag', 'unid', unid);
                    localVarPath = "/admins/feature-flags/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminDeleteFirmwareFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFirmware: function (firmwareType, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firmwareType' is not null or undefined
                    common_1.assertParamExists('adminDeleteFirmware', 'firmwareType', firmwareType);
                    // verify required parameter 'version' is not null or undefined
                    common_1.assertParamExists('adminDeleteFirmware', 'version', version);
                    localVarPath = "/admins/firmware-versions/{firmwareType}/{version}"
                        .replace('{firmwareType}', encodeURIComponent(String(firmwareType)))
                        .replace('{version}', encodeURIComponent(String(version)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFleetManagementAdministrator: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminDeleteFleetManagementAdministrator', 'unid', unid);
                    localVarPath = "/admins/fleet-management-administrators/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfAdmins: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminFetchPageOfAdmins', 'pageNumber', pageNumber);
                    localVarPath = "/admins/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfFleetManagementAdministrators: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminFetchPageOfFleetManagementAdministrators', 'pageNumber', pageNumber);
                    localVarPath = "/admins/fleet-management-administrators";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchSelf: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchSingleAdmin: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminFetchSingleAdmin', 'unid', unid);
                    localVarPath = "/admins/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCurrentLimit: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminGetCurrentLimit', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/current-limit"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDataStreamingShadow: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminGetDataStreamingShadow', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/data-streaming-shadow"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeviceDetails: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminGetDeviceDetails', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeviceGroup: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminGetDeviceGroup', 'unid', unid);
                    localVarPath = "/admins/device-groups/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDevices: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminGetDevices', 'pageNumber', pageNumber);
                    localVarPath = "/admins/devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeatureFlag: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminGetFeatureFlag', 'unid', unid);
                    localVarPath = "/admins/feature-flags/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminGetFirmwareFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFirmware: function (firmwareType, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firmwareType' is not null or undefined
                    common_1.assertParamExists('adminGetFirmware', 'firmwareType', firmwareType);
                    // verify required parameter 'version' is not null or undefined
                    common_1.assertParamExists('adminGetFirmware', 'version', version);
                    localVarPath = "/admins/firmware-versions/{firmwareType}/{version}"
                        .replace('{firmwareType}', encodeURIComponent(String(firmwareType)))
                        .replace('{version}', encodeURIComponent(String(version)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMinimumAppVersions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/minimum-app-version";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPageOfAppFirmwareVersionCompatibility: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminGetPageOfAppFirmwareVersionCompatibility', 'pageNumber', pageNumber);
                    localVarPath = "/admins/app-firmware-version-compatibility";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPageOfFeatureFlags: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminGetPageOfFeatureFlags', 'pageNumber', pageNumber);
                    localVarPath = "/admins/feature-flags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSyncDevicesJobStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/sync-devices/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListDeviceGroups: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/device-groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFirmware: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminListFirmware', 'pageNumber', pageNumber);
                    localVarPath = "/admins/firmware-versions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminListFirmwareS3OptionsFirmwareTypeEnum} firmwareType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFirmwareS3Options: function (firmwareType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firmwareType' is not null or undefined
                    common_1.assertParamExists('adminListFirmwareS3Options', 'firmwareType', firmwareType);
                    localVarPath = "/admins/firmware-s3-options/{firmwareType}"
                        .replace('{firmwareType}', encodeURIComponent(String(firmwareType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPingDevice: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminPingDevice', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/ping"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveUsersFromDevice: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminRemoveUsersFromDevice', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/users"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRestartDevice: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminRestartDevice', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/restart"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string} searchQuery
         * @param {AdminSearchDevicesPaginatedSearchTypeEnum} searchType
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchDevicesPaginated: function (pageNumber, searchQuery, searchType, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminSearchDevicesPaginated', 'pageNumber', pageNumber);
                    // verify required parameter 'searchQuery' is not null or undefined
                    common_1.assertParamExists('adminSearchDevicesPaginated', 'searchQuery', searchQuery);
                    // verify required parameter 'searchType' is not null or undefined
                    common_1.assertParamExists('adminSearchDevicesPaginated', 'searchType', searchType);
                    localVarPath = "/admins/search-devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (searchQuery !== undefined) {
                        localVarQueryParameter['searchQuery'] = searchQuery;
                    }
                    if (searchType !== undefined) {
                        localVarQueryParameter['searchType'] = searchType;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncDevices: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/sync-devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateAdminInput} [adminUpdateAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAdmin: function (unid, adminUpdateAdminInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminUpdateAdmin', 'unid', unid);
                    localVarPath = "/admins/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateAdminInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateAppFirmwareVersionCompatibilityInput} [adminUpdateAppFirmwareVersionCompatibilityInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAppFirmwareVersionCompatibility: function (unid, adminUpdateAppFirmwareVersionCompatibilityInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminUpdateAppFirmwareVersionCompatibility', 'unid', unid);
                    localVarPath = "/admins/app-firmware-version-compatibility/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateAppFirmwareVersionCompatibilityInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminUpdateCurrentLimitInput} [adminUpdateCurrentLimitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCurrentLimit: function (deviceUnid, adminUpdateCurrentLimitInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminUpdateCurrentLimit', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/current-limit"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateCurrentLimitInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminUpdateDataStreamingShadowInput} [adminUpdateDataStreamingShadowInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDataStreamingShadow: function (deviceUnid, adminUpdateDataStreamingShadowInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminUpdateDataStreamingShadow', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/data-streaming-shadow"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateDataStreamingShadowInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateDeviceGroupInput} [adminUpdateDeviceGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDeviceGroup: function (unid, adminUpdateDeviceGroupInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminUpdateDeviceGroup', 'unid', unid);
                    localVarPath = "/admins/device-groups/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateDeviceGroupInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateFeatureFlagInput} [adminUpdateFeatureFlagInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateFeatureFlag: function (unid, adminUpdateFeatureFlagInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminUpdateFeatureFlag', 'unid', unid);
                    localVarPath = "/admins/feature-flags/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateFeatureFlagInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} platform
         * @param {AdminUpdateMinimumAppVersionInput} [adminUpdateMinimumAppVersionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateMinimumAppVersion: function (platform, adminUpdateMinimumAppVersionInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'platform' is not null or undefined
                    common_1.assertParamExists('adminUpdateMinimumAppVersion', 'platform', platform);
                    localVarPath = "/admins/minimum-app-version/{platform}"
                        .replace('{platform}', encodeURIComponent(String(platform)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateMinimumAppVersionInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppFirmwareVersionCompatibilityOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/app-firmware-version-compatibility";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppFirmwareVersionCompatibilityUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminsAppFirmwareVersionCompatibilityUnidOptions', 'unid', unid);
                    localVarPath = "/admins/app-firmware-version-compatibility/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCustomFirmwareDevicesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/custom-firmware-devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeviceGroupsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/device-groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeviceGroupsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminsDeviceGroupsUnidOptions', 'unid', unid);
                    localVarPath = "/admins/device-groups/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidCurrentLimitOptions: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminsDevicesDeviceUnidCurrentLimitOptions', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/current-limit"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidDataStreamingShadowOptions: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminsDevicesDeviceUnidDataStreamingShadowOptions', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/data-streaming-shadow"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidOptions: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminsDevicesDeviceUnidOptions', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidPingOptions: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminsDevicesDeviceUnidPingOptions', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/ping"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidRestartOptions: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminsDevicesDeviceUnidRestartOptions', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/restart"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidUsersOptions: function (deviceUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceUnid' is not null or undefined
                    common_1.assertParamExists('adminsDevicesDeviceUnidUsersOptions', 'deviceUnid', deviceUnid);
                    localVarPath = "/admins/devices/{deviceUnid}/users"
                        .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFeatureFlagsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/feature-flags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFeatureFlagsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminsFeatureFlagsUnidOptions', 'unid', unid);
                    localVarPath = "/admins/feature-flags/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminsFirmwareS3OptionsFirmwareTypeOptionsFirmwareTypeEnum} firmwareType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareS3OptionsFirmwareTypeOptions: function (firmwareType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firmwareType' is not null or undefined
                    common_1.assertParamExists('adminsFirmwareS3OptionsFirmwareTypeOptions', 'firmwareType', firmwareType);
                    localVarPath = "/admins/firmware-s3-options/{firmwareType}"
                        .replace('{firmwareType}', encodeURIComponent(String(firmwareType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AdminsFirmwareVersionsFirmwareTypeVersionOptionsFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareVersionsFirmwareTypeVersionOptions: function (firmwareType, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firmwareType' is not null or undefined
                    common_1.assertParamExists('adminsFirmwareVersionsFirmwareTypeVersionOptions', 'firmwareType', firmwareType);
                    // verify required parameter 'version' is not null or undefined
                    common_1.assertParamExists('adminsFirmwareVersionsFirmwareTypeVersionOptions', 'version', version);
                    localVarPath = "/admins/firmware-versions/{firmwareType}/{version}"
                        .replace('{firmwareType}', encodeURIComponent(String(firmwareType)))
                        .replace('{version}', encodeURIComponent(String(version)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareVersionsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/firmware-versions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFleetManagementAdministratorsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/fleet-management-administrators";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFleetManagementAdministratorsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminsFleetManagementAdministratorsUnidOptions', 'unid', unid);
                    localVarPath = "/admins/fleet-management-administrators/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoginOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLogoutOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMeOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMinimumAppVersionOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/minimum-app-version";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMinimumAppVersionPlatformOptions: function (platform, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'platform' is not null or undefined
                    common_1.assertParamExists('adminsMinimumAppVersionPlatformOptions', 'platform', platform);
                    localVarPath = "/admins/minimum-app-version/{platform}"
                        .replace('{platform}', encodeURIComponent(String(platform)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSearchDevicesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/search-devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsStartOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/start";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSyncDevicesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/sync-devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSyncDevicesStatusOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/sync-devices/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminsUnidOptions', 'unid', unid);
                    localVarPath = "/admins/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAccountAdmin: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    common_1.assertParamExists('loginAccountAdmin', 'token', token);
                    localVarPath = "/admins/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (token != null) {
                        localVarHeaderParameter['token'] = String(token);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAccountAdmin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {StartLoginAdminInput} [startLoginAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startLoginAdmin: function (startLoginAdminInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admins/start";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(startLoginAdminInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AdminsApiAxiosParamCreator = AdminsApiAxiosParamCreator;
/**
 * AdminsApi - functional programming interface
 */
var AdminsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AdminsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AdminAddDeviceSearchesToCustomFirmwareInput} [adminAddDeviceSearchesToCustomFirmwareInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddDeviceSearchesToCustomFirmware: function (adminAddDeviceSearchesToCustomFirmwareInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminAddDeviceSearchesToCustomFirmware(adminAddDeviceSearchesToCustomFirmwareInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminAddDeviceSearchesToCustomFirmware']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminAddUserToDeviceInput} [adminAddUserToDeviceInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddUserToDevice: function (deviceUnid, adminAddUserToDeviceInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminAddUserToDevice(deviceUnid, adminAddUserToDeviceInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminAddUserToDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminCreateAdminInput} [adminCreateAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAdmin: function (adminCreateAdminInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateAdmin(adminCreateAdminInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminCreateAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminCreateAppFirmwareVersionCompatibilityInput} [adminCreateAppFirmwareVersionCompatibilityInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAppFirmwareVersionCompatibility: function (adminCreateAppFirmwareVersionCompatibilityInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateAppFirmwareVersionCompatibility(adminCreateAppFirmwareVersionCompatibilityInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminCreateAppFirmwareVersionCompatibility']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminCreateDeviceGroupInput} [adminCreateDeviceGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateDeviceGroup: function (adminCreateDeviceGroupInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateDeviceGroup(adminCreateDeviceGroupInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminCreateDeviceGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminCreateFeatureFlagInput} [adminCreateFeatureFlagInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFeatureFlag: function (adminCreateFeatureFlagInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateFeatureFlag(adminCreateFeatureFlagInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminCreateFeatureFlag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminCreateFirmwareInput} [adminCreateFirmwareInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFirmware: function (adminCreateFirmwareInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateFirmware(adminCreateFirmwareInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminCreateFirmware']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminCreateOrInviteFleetManagementAdministratorInput} [adminCreateOrInviteFleetManagementAdministratorInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrInviteFleetManagementAdministrator: function (adminCreateOrInviteFleetManagementAdministratorInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateOrInviteFleetManagementAdministrator(adminCreateOrInviteFleetManagementAdministratorInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminCreateOrInviteFleetManagementAdministrator']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAdmin: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteAdmin(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminDeleteAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAppFirmwareVersionCompatibility: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteAppFirmwareVersionCompatibility(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminDeleteAppFirmwareVersionCompatibility']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDeviceGroup: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteDeviceGroup(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminDeleteDeviceGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFeatureFlag: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteFeatureFlag(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminDeleteFeatureFlag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminDeleteFirmwareFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFirmware: function (firmwareType, version, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteFirmware(firmwareType, version, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminDeleteFirmware']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFleetManagementAdministrator: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteFleetManagementAdministrator(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminDeleteFleetManagementAdministrator']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfAdmins: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminFetchPageOfAdmins(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminFetchPageOfAdmins']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfFleetManagementAdministrators: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminFetchPageOfFleetManagementAdministrators(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminFetchPageOfFleetManagementAdministrators']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchSelf: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminFetchSelf(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminFetchSelf']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchSingleAdmin: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminFetchSingleAdmin(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminFetchSingleAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCurrentLimit: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetCurrentLimit(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetCurrentLimit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDataStreamingShadow: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetDataStreamingShadow(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetDataStreamingShadow']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeviceDetails: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetDeviceDetails(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetDeviceDetails']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeviceGroup: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetDeviceGroup(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetDeviceGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDevices: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetDevices(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeatureFlag: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetFeatureFlag(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetFeatureFlag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminGetFirmwareFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFirmware: function (firmwareType, version, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetFirmware(firmwareType, version, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetFirmware']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMinimumAppVersions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetMinimumAppVersions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetMinimumAppVersions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPageOfAppFirmwareVersionCompatibility: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetPageOfAppFirmwareVersionCompatibility(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetPageOfAppFirmwareVersionCompatibility']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPageOfFeatureFlags: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetPageOfFeatureFlags(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetPageOfFeatureFlags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSyncDevicesJobStatus: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetSyncDevicesJobStatus(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminGetSyncDevicesJobStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListDeviceGroups: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminListDeviceGroups(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminListDeviceGroups']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFirmware: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminListFirmware(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminListFirmware']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminListFirmwareS3OptionsFirmwareTypeEnum} firmwareType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFirmwareS3Options: function (firmwareType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminListFirmwareS3Options(firmwareType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminListFirmwareS3Options']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPingDevice: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminPingDevice(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminPingDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveUsersFromDevice: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminRemoveUsersFromDevice(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminRemoveUsersFromDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRestartDevice: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminRestartDevice(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminRestartDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string} searchQuery
         * @param {AdminSearchDevicesPaginatedSearchTypeEnum} searchType
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchDevicesPaginated: function (pageNumber, searchQuery, searchType, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminSearchDevicesPaginated(pageNumber, searchQuery, searchType, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminSearchDevicesPaginated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncDevices: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminSyncDevices(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminSyncDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateAdminInput} [adminUpdateAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAdmin: function (unid, adminUpdateAdminInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateAdmin(unid, adminUpdateAdminInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateAppFirmwareVersionCompatibilityInput} [adminUpdateAppFirmwareVersionCompatibilityInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAppFirmwareVersionCompatibility: function (unid, adminUpdateAppFirmwareVersionCompatibilityInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateAppFirmwareVersionCompatibility(unid, adminUpdateAppFirmwareVersionCompatibilityInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateAppFirmwareVersionCompatibility']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminUpdateCurrentLimitInput} [adminUpdateCurrentLimitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCurrentLimit: function (deviceUnid, adminUpdateCurrentLimitInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateCurrentLimit(deviceUnid, adminUpdateCurrentLimitInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateCurrentLimit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminUpdateDataStreamingShadowInput} [adminUpdateDataStreamingShadowInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDataStreamingShadow: function (deviceUnid, adminUpdateDataStreamingShadowInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateDataStreamingShadow(deviceUnid, adminUpdateDataStreamingShadowInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateDataStreamingShadow']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateDeviceGroupInput} [adminUpdateDeviceGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDeviceGroup: function (unid, adminUpdateDeviceGroupInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateDeviceGroup(unid, adminUpdateDeviceGroupInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateDeviceGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateFeatureFlagInput} [adminUpdateFeatureFlagInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateFeatureFlag: function (unid, adminUpdateFeatureFlagInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateFeatureFlag(unid, adminUpdateFeatureFlagInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateFeatureFlag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} platform
         * @param {AdminUpdateMinimumAppVersionInput} [adminUpdateMinimumAppVersionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateMinimumAppVersion: function (platform, adminUpdateMinimumAppVersionInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateMinimumAppVersion(platform, adminUpdateMinimumAppVersionInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminUpdateMinimumAppVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppFirmwareVersionCompatibilityOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsAppFirmwareVersionCompatibilityOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsAppFirmwareVersionCompatibilityOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppFirmwareVersionCompatibilityUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsAppFirmwareVersionCompatibilityUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsAppFirmwareVersionCompatibilityUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCustomFirmwareDevicesOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsCustomFirmwareDevicesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsCustomFirmwareDevicesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeviceGroupsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDeviceGroupsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDeviceGroupsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeviceGroupsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDeviceGroupsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDeviceGroupsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidCurrentLimitOptions: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesDeviceUnidCurrentLimitOptions(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesDeviceUnidCurrentLimitOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidDataStreamingShadowOptions: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesDeviceUnidDataStreamingShadowOptions(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesDeviceUnidDataStreamingShadowOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidOptions: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesDeviceUnidOptions(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesDeviceUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidPingOptions: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesDeviceUnidPingOptions(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesDeviceUnidPingOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidRestartOptions: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesDeviceUnidRestartOptions(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesDeviceUnidRestartOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidUsersOptions: function (deviceUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesDeviceUnidUsersOptions(deviceUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesDeviceUnidUsersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsDevicesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsDevicesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFeatureFlagsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFeatureFlagsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFeatureFlagsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFeatureFlagsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFeatureFlagsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFeatureFlagsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminsFirmwareS3OptionsFirmwareTypeOptionsFirmwareTypeEnum} firmwareType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareS3OptionsFirmwareTypeOptions: function (firmwareType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFirmwareS3OptionsFirmwareTypeOptions(firmwareType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFirmwareS3OptionsFirmwareTypeOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {AdminsFirmwareVersionsFirmwareTypeVersionOptionsFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareVersionsFirmwareTypeVersionOptions: function (firmwareType, version, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFirmwareVersionsFirmwareTypeVersionOptions(firmwareType, version, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFirmwareVersionsFirmwareTypeVersionOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareVersionsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFirmwareVersionsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFirmwareVersionsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFleetManagementAdministratorsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFleetManagementAdministratorsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFleetManagementAdministratorsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFleetManagementAdministratorsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsFleetManagementAdministratorsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsFleetManagementAdministratorsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoginOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsLoginOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsLoginOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLogoutOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsLogoutOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsLogoutOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMeOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsMeOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsMeOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMinimumAppVersionOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsMinimumAppVersionOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsMinimumAppVersionOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMinimumAppVersionPlatformOptions: function (platform, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsMinimumAppVersionPlatformOptions(platform, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsMinimumAppVersionPlatformOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSearchDevicesOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsSearchDevicesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsSearchDevicesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsStartOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsStartOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsStartOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSyncDevicesOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsSyncDevicesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsSyncDevicesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSyncDevicesStatusOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsSyncDevicesStatusOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsSyncDevicesStatusOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.adminsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAccountAdmin: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginAccountAdmin(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.loginAccountAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAccountAdmin: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logoutAccountAdmin(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.logoutAccountAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {StartLoginAdminInput} [startLoginAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startLoginAdmin: function (startLoginAdminInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.startLoginAdmin(startLoginAdminInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminsApi.startLoginAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AdminsApiFp = AdminsApiFp;
/**
 * AdminsApi - factory interface
 */
var AdminsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AdminsApiFp(configuration);
    return {
        /**
         *
         * @param {AdminAddDeviceSearchesToCustomFirmwareInput} [adminAddDeviceSearchesToCustomFirmwareInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddDeviceSearchesToCustomFirmware: function (adminAddDeviceSearchesToCustomFirmwareInput, options) {
            return localVarFp.adminAddDeviceSearchesToCustomFirmware(adminAddDeviceSearchesToCustomFirmwareInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminAddUserToDeviceInput} [adminAddUserToDeviceInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddUserToDevice: function (deviceUnid, adminAddUserToDeviceInput, options) {
            return localVarFp.adminAddUserToDevice(deviceUnid, adminAddUserToDeviceInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminCreateAdminInput} [adminCreateAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAdmin: function (adminCreateAdminInput, options) {
            return localVarFp.adminCreateAdmin(adminCreateAdminInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminCreateAppFirmwareVersionCompatibilityInput} [adminCreateAppFirmwareVersionCompatibilityInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAppFirmwareVersionCompatibility: function (adminCreateAppFirmwareVersionCompatibilityInput, options) {
            return localVarFp.adminCreateAppFirmwareVersionCompatibility(adminCreateAppFirmwareVersionCompatibilityInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminCreateDeviceGroupInput} [adminCreateDeviceGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateDeviceGroup: function (adminCreateDeviceGroupInput, options) {
            return localVarFp.adminCreateDeviceGroup(adminCreateDeviceGroupInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminCreateFeatureFlagInput} [adminCreateFeatureFlagInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFeatureFlag: function (adminCreateFeatureFlagInput, options) {
            return localVarFp.adminCreateFeatureFlag(adminCreateFeatureFlagInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminCreateFirmwareInput} [adminCreateFirmwareInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFirmware: function (adminCreateFirmwareInput, options) {
            return localVarFp.adminCreateFirmware(adminCreateFirmwareInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminCreateOrInviteFleetManagementAdministratorInput} [adminCreateOrInviteFleetManagementAdministratorInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrInviteFleetManagementAdministrator: function (adminCreateOrInviteFleetManagementAdministratorInput, options) {
            return localVarFp.adminCreateOrInviteFleetManagementAdministrator(adminCreateOrInviteFleetManagementAdministratorInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAdmin: function (unid, options) {
            return localVarFp.adminDeleteAdmin(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAppFirmwareVersionCompatibility: function (unid, options) {
            return localVarFp.adminDeleteAppFirmwareVersionCompatibility(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDeviceGroup: function (unid, options) {
            return localVarFp.adminDeleteDeviceGroup(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFeatureFlag: function (unid, options) {
            return localVarFp.adminDeleteFeatureFlag(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminDeleteFirmwareFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFirmware: function (firmwareType, version, options) {
            return localVarFp.adminDeleteFirmware(firmwareType, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFleetManagementAdministrator: function (unid, options) {
            return localVarFp.adminDeleteFleetManagementAdministrator(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfAdmins: function (pageNumber, pageSize, options) {
            return localVarFp.adminFetchPageOfAdmins(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfFleetManagementAdministrators: function (pageNumber, pageSize, options) {
            return localVarFp.adminFetchPageOfFleetManagementAdministrators(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchSelf: function (options) {
            return localVarFp.adminFetchSelf(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchSingleAdmin: function (unid, options) {
            return localVarFp.adminFetchSingleAdmin(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCurrentLimit: function (deviceUnid, options) {
            return localVarFp.adminGetCurrentLimit(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDataStreamingShadow: function (deviceUnid, options) {
            return localVarFp.adminGetDataStreamingShadow(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeviceDetails: function (deviceUnid, options) {
            return localVarFp.adminGetDeviceDetails(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeviceGroup: function (unid, options) {
            return localVarFp.adminGetDeviceGroup(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDevices: function (pageNumber, pageSize, options) {
            return localVarFp.adminGetDevices(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeatureFlag: function (unid, options) {
            return localVarFp.adminGetFeatureFlag(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminGetFirmwareFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFirmware: function (firmwareType, version, options) {
            return localVarFp.adminGetFirmware(firmwareType, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMinimumAppVersions: function (options) {
            return localVarFp.adminGetMinimumAppVersions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPageOfAppFirmwareVersionCompatibility: function (pageNumber, pageSize, options) {
            return localVarFp.adminGetPageOfAppFirmwareVersionCompatibility(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPageOfFeatureFlags: function (pageNumber, pageSize, options) {
            return localVarFp.adminGetPageOfFeatureFlags(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSyncDevicesJobStatus: function (options) {
            return localVarFp.adminGetSyncDevicesJobStatus(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListDeviceGroups: function (options) {
            return localVarFp.adminListDeviceGroups(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFirmware: function (pageNumber, pageSize, options) {
            return localVarFp.adminListFirmware(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminListFirmwareS3OptionsFirmwareTypeEnum} firmwareType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFirmwareS3Options: function (firmwareType, options) {
            return localVarFp.adminListFirmwareS3Options(firmwareType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPingDevice: function (deviceUnid, options) {
            return localVarFp.adminPingDevice(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveUsersFromDevice: function (deviceUnid, options) {
            return localVarFp.adminRemoveUsersFromDevice(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRestartDevice: function (deviceUnid, options) {
            return localVarFp.adminRestartDevice(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string} searchQuery
         * @param {AdminSearchDevicesPaginatedSearchTypeEnum} searchType
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchDevicesPaginated: function (pageNumber, searchQuery, searchType, pageSize, options) {
            return localVarFp.adminSearchDevicesPaginated(pageNumber, searchQuery, searchType, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncDevices: function (options) {
            return localVarFp.adminSyncDevices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateAdminInput} [adminUpdateAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAdmin: function (unid, adminUpdateAdminInput, options) {
            return localVarFp.adminUpdateAdmin(unid, adminUpdateAdminInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateAppFirmwareVersionCompatibilityInput} [adminUpdateAppFirmwareVersionCompatibilityInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAppFirmwareVersionCompatibility: function (unid, adminUpdateAppFirmwareVersionCompatibilityInput, options) {
            return localVarFp.adminUpdateAppFirmwareVersionCompatibility(unid, adminUpdateAppFirmwareVersionCompatibilityInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminUpdateCurrentLimitInput} [adminUpdateCurrentLimitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCurrentLimit: function (deviceUnid, adminUpdateCurrentLimitInput, options) {
            return localVarFp.adminUpdateCurrentLimit(deviceUnid, adminUpdateCurrentLimitInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {AdminUpdateDataStreamingShadowInput} [adminUpdateDataStreamingShadowInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDataStreamingShadow: function (deviceUnid, adminUpdateDataStreamingShadowInput, options) {
            return localVarFp.adminUpdateDataStreamingShadow(deviceUnid, adminUpdateDataStreamingShadowInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateDeviceGroupInput} [adminUpdateDeviceGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDeviceGroup: function (unid, adminUpdateDeviceGroupInput, options) {
            return localVarFp.adminUpdateDeviceGroup(unid, adminUpdateDeviceGroupInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminUpdateFeatureFlagInput} [adminUpdateFeatureFlagInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateFeatureFlag: function (unid, adminUpdateFeatureFlagInput, options) {
            return localVarFp.adminUpdateFeatureFlag(unid, adminUpdateFeatureFlagInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} platform
         * @param {AdminUpdateMinimumAppVersionInput} [adminUpdateMinimumAppVersionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateMinimumAppVersion: function (platform, adminUpdateMinimumAppVersionInput, options) {
            return localVarFp.adminUpdateMinimumAppVersion(platform, adminUpdateMinimumAppVersionInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppFirmwareVersionCompatibilityOptions: function (options) {
            return localVarFp.adminsAppFirmwareVersionCompatibilityOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsAppFirmwareVersionCompatibilityUnidOptions: function (unid, options) {
            return localVarFp.adminsAppFirmwareVersionCompatibilityUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsCustomFirmwareDevicesOptions: function (options) {
            return localVarFp.adminsCustomFirmwareDevicesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeviceGroupsOptions: function (options) {
            return localVarFp.adminsDeviceGroupsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDeviceGroupsUnidOptions: function (unid, options) {
            return localVarFp.adminsDeviceGroupsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidCurrentLimitOptions: function (deviceUnid, options) {
            return localVarFp.adminsDevicesDeviceUnidCurrentLimitOptions(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidDataStreamingShadowOptions: function (deviceUnid, options) {
            return localVarFp.adminsDevicesDeviceUnidDataStreamingShadowOptions(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidOptions: function (deviceUnid, options) {
            return localVarFp.adminsDevicesDeviceUnidOptions(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidPingOptions: function (deviceUnid, options) {
            return localVarFp.adminsDevicesDeviceUnidPingOptions(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidRestartOptions: function (deviceUnid, options) {
            return localVarFp.adminsDevicesDeviceUnidRestartOptions(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesDeviceUnidUsersOptions: function (deviceUnid, options) {
            return localVarFp.adminsDevicesDeviceUnidUsersOptions(deviceUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsDevicesOptions: function (options) {
            return localVarFp.adminsDevicesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFeatureFlagsOptions: function (options) {
            return localVarFp.adminsFeatureFlagsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFeatureFlagsUnidOptions: function (unid, options) {
            return localVarFp.adminsFeatureFlagsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminsFirmwareS3OptionsFirmwareTypeOptionsFirmwareTypeEnum} firmwareType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareS3OptionsFirmwareTypeOptions: function (firmwareType, options) {
            return localVarFp.adminsFirmwareS3OptionsFirmwareTypeOptions(firmwareType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AdminsFirmwareVersionsFirmwareTypeVersionOptionsFirmwareTypeEnum} firmwareType
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareVersionsFirmwareTypeVersionOptions: function (firmwareType, version, options) {
            return localVarFp.adminsFirmwareVersionsFirmwareTypeVersionOptions(firmwareType, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFirmwareVersionsOptions: function (options) {
            return localVarFp.adminsFirmwareVersionsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFleetManagementAdministratorsOptions: function (options) {
            return localVarFp.adminsFleetManagementAdministratorsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsFleetManagementAdministratorsUnidOptions: function (unid, options) {
            return localVarFp.adminsFleetManagementAdministratorsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLoginOptions: function (options) {
            return localVarFp.adminsLoginOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsLogoutOptions: function (options) {
            return localVarFp.adminsLogoutOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMeOptions: function (options) {
            return localVarFp.adminsMeOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMinimumAppVersionOptions: function (options) {
            return localVarFp.adminsMinimumAppVersionOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsMinimumAppVersionPlatformOptions: function (platform, options) {
            return localVarFp.adminsMinimumAppVersionPlatformOptions(platform, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsOptions: function (options) {
            return localVarFp.adminsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSearchDevicesOptions: function (options) {
            return localVarFp.adminsSearchDevicesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsStartOptions: function (options) {
            return localVarFp.adminsStartOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSyncDevicesOptions: function (options) {
            return localVarFp.adminsSyncDevicesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsSyncDevicesStatusOptions: function (options) {
            return localVarFp.adminsSyncDevicesStatusOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsUnidOptions: function (unid, options) {
            return localVarFp.adminsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAccountAdmin: function (token, options) {
            return localVarFp.loginAccountAdmin(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAccountAdmin: function (options) {
            return localVarFp.logoutAccountAdmin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {StartLoginAdminInput} [startLoginAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startLoginAdmin: function (startLoginAdminInput, options) {
            return localVarFp.startLoginAdmin(startLoginAdminInput, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminsApiFactory = AdminsApiFactory;
/**
 * AdminsApi - object-oriented interface
 */
var AdminsApi = /** @class */ (function (_super) {
    __extends(AdminsApi, _super);
    function AdminsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AdminAddDeviceSearchesToCustomFirmwareInput} [adminAddDeviceSearchesToCustomFirmwareInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminAddDeviceSearchesToCustomFirmware = function (adminAddDeviceSearchesToCustomFirmwareInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminAddDeviceSearchesToCustomFirmware(adminAddDeviceSearchesToCustomFirmwareInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {AdminAddUserToDeviceInput} [adminAddUserToDeviceInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminAddUserToDevice = function (deviceUnid, adminAddUserToDeviceInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminAddUserToDevice(deviceUnid, adminAddUserToDeviceInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminCreateAdminInput} [adminCreateAdminInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminCreateAdmin = function (adminCreateAdminInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminCreateAdmin(adminCreateAdminInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminCreateAppFirmwareVersionCompatibilityInput} [adminCreateAppFirmwareVersionCompatibilityInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminCreateAppFirmwareVersionCompatibility = function (adminCreateAppFirmwareVersionCompatibilityInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminCreateAppFirmwareVersionCompatibility(adminCreateAppFirmwareVersionCompatibilityInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminCreateDeviceGroupInput} [adminCreateDeviceGroupInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminCreateDeviceGroup = function (adminCreateDeviceGroupInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminCreateDeviceGroup(adminCreateDeviceGroupInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminCreateFeatureFlagInput} [adminCreateFeatureFlagInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminCreateFeatureFlag = function (adminCreateFeatureFlagInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminCreateFeatureFlag(adminCreateFeatureFlagInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminCreateFirmwareInput} [adminCreateFirmwareInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminCreateFirmware = function (adminCreateFirmwareInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminCreateFirmware(adminCreateFirmwareInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminCreateOrInviteFleetManagementAdministratorInput} [adminCreateOrInviteFleetManagementAdministratorInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminCreateOrInviteFleetManagementAdministrator = function (adminCreateOrInviteFleetManagementAdministratorInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminCreateOrInviteFleetManagementAdministrator(adminCreateOrInviteFleetManagementAdministratorInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminDeleteAdmin = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminDeleteAdmin(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminDeleteAppFirmwareVersionCompatibility = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminDeleteAppFirmwareVersionCompatibility(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminDeleteDeviceGroup = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminDeleteDeviceGroup(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminDeleteFeatureFlag = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminDeleteFeatureFlag(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminDeleteFirmwareFirmwareTypeEnum} firmwareType
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminDeleteFirmware = function (firmwareType, version, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminDeleteFirmware(firmwareType, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminDeleteFleetManagementAdministrator = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminDeleteFleetManagementAdministrator(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminFetchPageOfAdmins = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminFetchPageOfAdmins(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminFetchPageOfFleetManagementAdministrators = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminFetchPageOfFleetManagementAdministrators(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminFetchSelf = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminFetchSelf(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminFetchSingleAdmin = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminFetchSingleAdmin(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetCurrentLimit = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetCurrentLimit(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetDataStreamingShadow = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetDataStreamingShadow(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetDeviceDetails = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetDeviceDetails(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetDeviceGroup = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetDeviceGroup(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetDevices = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetDevices(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetFeatureFlag = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetFeatureFlag(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminGetFirmwareFirmwareTypeEnum} firmwareType
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetFirmware = function (firmwareType, version, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetFirmware(firmwareType, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetMinimumAppVersions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetMinimumAppVersions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetPageOfAppFirmwareVersionCompatibility = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetPageOfAppFirmwareVersionCompatibility(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetPageOfFeatureFlags = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetPageOfFeatureFlags(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminGetSyncDevicesJobStatus = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminGetSyncDevicesJobStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminListDeviceGroups = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminListDeviceGroups(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminListFirmware = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminListFirmware(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminListFirmwareS3OptionsFirmwareTypeEnum} firmwareType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminListFirmwareS3Options = function (firmwareType, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminListFirmwareS3Options(firmwareType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminPingDevice = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminPingDevice(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminRemoveUsersFromDevice = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminRemoveUsersFromDevice(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminRestartDevice = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminRestartDevice(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {string} searchQuery
     * @param {AdminSearchDevicesPaginatedSearchTypeEnum} searchType
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminSearchDevicesPaginated = function (pageNumber, searchQuery, searchType, pageSize, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminSearchDevicesPaginated(pageNumber, searchQuery, searchType, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminSyncDevices = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminSyncDevices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {AdminUpdateAdminInput} [adminUpdateAdminInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateAdmin = function (unid, adminUpdateAdminInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateAdmin(unid, adminUpdateAdminInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {AdminUpdateAppFirmwareVersionCompatibilityInput} [adminUpdateAppFirmwareVersionCompatibilityInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateAppFirmwareVersionCompatibility = function (unid, adminUpdateAppFirmwareVersionCompatibilityInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateAppFirmwareVersionCompatibility(unid, adminUpdateAppFirmwareVersionCompatibilityInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {AdminUpdateCurrentLimitInput} [adminUpdateCurrentLimitInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateCurrentLimit = function (deviceUnid, adminUpdateCurrentLimitInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateCurrentLimit(deviceUnid, adminUpdateCurrentLimitInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {AdminUpdateDataStreamingShadowInput} [adminUpdateDataStreamingShadowInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateDataStreamingShadow = function (deviceUnid, adminUpdateDataStreamingShadowInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateDataStreamingShadow(deviceUnid, adminUpdateDataStreamingShadowInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {AdminUpdateDeviceGroupInput} [adminUpdateDeviceGroupInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateDeviceGroup = function (unid, adminUpdateDeviceGroupInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateDeviceGroup(unid, adminUpdateDeviceGroupInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {AdminUpdateFeatureFlagInput} [adminUpdateFeatureFlagInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateFeatureFlag = function (unid, adminUpdateFeatureFlagInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateFeatureFlag(unid, adminUpdateFeatureFlagInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} platform
     * @param {AdminUpdateMinimumAppVersionInput} [adminUpdateMinimumAppVersionInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminUpdateMinimumAppVersion = function (platform, adminUpdateMinimumAppVersionInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminUpdateMinimumAppVersion(platform, adminUpdateMinimumAppVersionInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsAppFirmwareVersionCompatibilityOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsAppFirmwareVersionCompatibilityOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsAppFirmwareVersionCompatibilityUnidOptions = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsAppFirmwareVersionCompatibilityUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsCustomFirmwareDevicesOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsCustomFirmwareDevicesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDeviceGroupsOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDeviceGroupsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDeviceGroupsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDeviceGroupsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesDeviceUnidCurrentLimitOptions = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesDeviceUnidCurrentLimitOptions(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesDeviceUnidDataStreamingShadowOptions = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesDeviceUnidDataStreamingShadowOptions(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesDeviceUnidOptions = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesDeviceUnidOptions(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesDeviceUnidPingOptions = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesDeviceUnidPingOptions(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesDeviceUnidRestartOptions = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesDeviceUnidRestartOptions(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesDeviceUnidUsersOptions = function (deviceUnid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesDeviceUnidUsersOptions(deviceUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsDevicesOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsDevicesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFeatureFlagsOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFeatureFlagsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFeatureFlagsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFeatureFlagsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminsFirmwareS3OptionsFirmwareTypeOptionsFirmwareTypeEnum} firmwareType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFirmwareS3OptionsFirmwareTypeOptions = function (firmwareType, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFirmwareS3OptionsFirmwareTypeOptions(firmwareType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AdminsFirmwareVersionsFirmwareTypeVersionOptionsFirmwareTypeEnum} firmwareType
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFirmwareVersionsFirmwareTypeVersionOptions = function (firmwareType, version, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFirmwareVersionsFirmwareTypeVersionOptions(firmwareType, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFirmwareVersionsOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFirmwareVersionsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFleetManagementAdministratorsOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFleetManagementAdministratorsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsFleetManagementAdministratorsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsFleetManagementAdministratorsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsLoginOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsLoginOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsLogoutOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsLogoutOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsMeOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsMeOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsMinimumAppVersionOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsMinimumAppVersionOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsMinimumAppVersionPlatformOptions = function (platform, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsMinimumAppVersionPlatformOptions(platform, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsSearchDevicesOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsSearchDevicesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsStartOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsStartOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsSyncDevicesOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsSyncDevicesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsSyncDevicesStatusOptions = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsSyncDevicesStatusOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.adminsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).adminsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.loginAccountAdmin = function (token, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).loginAccountAdmin(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.logoutAccountAdmin = function (options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).logoutAccountAdmin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {StartLoginAdminInput} [startLoginAdminInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminsApi.prototype.startLoginAdmin = function (startLoginAdminInput, options) {
        var _this = this;
        return exports.AdminsApiFp(this.configuration).startLoginAdmin(startLoginAdminInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminsApi;
}(base_1.BaseAPI));
exports.AdminsApi = AdminsApi;
exports.AdminDeleteFirmwareFirmwareTypeEnum = {
    Custom: 'custom',
    DenaliDefault: 'denali_default',
    FlagshipDefault: 'flagship_default',
};
exports.AdminGetFirmwareFirmwareTypeEnum = {
    Custom: 'custom',
    DenaliDefault: 'denali_default',
    FlagshipDefault: 'flagship_default',
};
exports.AdminListFirmwareS3OptionsFirmwareTypeEnum = {
    Custom: 'custom',
    DenaliDefault: 'denali_default',
    FlagshipDefault: 'flagship_default',
};
exports.AdminSearchDevicesPaginatedSearchTypeEnum = {
    IdbMacId: 'idbMacId',
    SimSn: 'simSn',
    Email: 'email',
    Name: 'name',
    ThingName: 'thingName',
    DeviceGroup: 'deviceGroup',
};
exports.AdminsFirmwareS3OptionsFirmwareTypeOptionsFirmwareTypeEnum = {
    Custom: 'custom',
    DenaliDefault: 'denali_default',
    FlagshipDefault: 'flagship_default',
};
exports.AdminsFirmwareVersionsFirmwareTypeVersionOptionsFirmwareTypeEnum = {
    Custom: 'custom',
    DenaliDefault: 'denali_default',
    FlagshipDefault: 'flagship_default',
};
/**
 * BluetoothRoutesApi - axios parameter creator
 */
var BluetoothRoutesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {LogBluetoothErrorInput} [logBluetoothErrorInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logBluetoothError: function (logBluetoothErrorInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/bt/errors";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(logBluetoothErrorInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BluetoothRoutesApiAxiosParamCreator = BluetoothRoutesApiAxiosParamCreator;
/**
 * BluetoothRoutesApi - functional programming interface
 */
var BluetoothRoutesApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.BluetoothRoutesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {LogBluetoothErrorInput} [logBluetoothErrorInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logBluetoothError: function (logBluetoothErrorInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logBluetoothError(logBluetoothErrorInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BluetoothRoutesApi.logBluetoothError']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.BluetoothRoutesApiFp = BluetoothRoutesApiFp;
/**
 * BluetoothRoutesApi - factory interface
 */
var BluetoothRoutesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.BluetoothRoutesApiFp(configuration);
    return {
        /**
         *
         * @param {LogBluetoothErrorInput} [logBluetoothErrorInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logBluetoothError: function (logBluetoothErrorInput, options) {
            return localVarFp.logBluetoothError(logBluetoothErrorInput, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BluetoothRoutesApiFactory = BluetoothRoutesApiFactory;
/**
 * BluetoothRoutesApi - object-oriented interface
 */
var BluetoothRoutesApi = /** @class */ (function (_super) {
    __extends(BluetoothRoutesApi, _super);
    function BluetoothRoutesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {LogBluetoothErrorInput} [logBluetoothErrorInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    BluetoothRoutesApi.prototype.logBluetoothError = function (logBluetoothErrorInput, options) {
        var _this = this;
        return exports.BluetoothRoutesApiFp(this.configuration).logBluetoothError(logBluetoothErrorInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BluetoothRoutesApi;
}(base_1.BaseAPI));
exports.BluetoothRoutesApi = BluetoothRoutesApi;
/**
 * DefaultApi - axios parameter creator
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {HandleAnalyticsMessageInput} [handleAnalyticsMessageInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleAnalyticsMessage: function (handleAnalyticsMessageInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/analytics";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(handleAnalyticsMessageInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {HandleClientConnectedInput} [handleClientConnectedInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleClientConnected: function (confirmationToken, iotKey, handleClientConnectedInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/clients/connected";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (confirmationToken !== undefined) {
                        localVarQueryParameter['confirmationToken'] = confirmationToken;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (iotKey != null) {
                        localVarHeaderParameter['iotKey'] = String(iotKey);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(handleClientConnectedInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<HandleQuickbooksWebhookRequestInner>} handleQuickbooksWebhookRequestInner
         * @param {string} [intuitSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQuickbooksWebhook: function (handleQuickbooksWebhookRequestInner, intuitSignature, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'handleQuickbooksWebhookRequestInner' is not null or undefined
                    common_1.assertParamExists('handleQuickbooksWebhook', 'handleQuickbooksWebhookRequestInner', handleQuickbooksWebhookRequestInner);
                    localVarPath = "/quickbooks/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (intuitSignature != null) {
                        localVarHeaderParameter['intuit-signature'] = String(intuitSignature);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(handleQuickbooksWebhookRequestInner, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} apiKey
         * @param {NotifyExternalAlertInput} [notifyExternalAlertInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyExternalAlert: function (apiKey, notifyExternalAlertInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'apiKey' is not null or undefined
                    common_1.assertParamExists('notifyExternalAlert', 'apiKey', apiKey);
                    localVarPath = "/airflow/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (apiKey != null) {
                        localVarHeaderParameter['apiKey'] = String(apiKey);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(notifyExternalAlertInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {HandleAnalyticsMessageInput} [handleAnalyticsMessageInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleAnalyticsMessage: function (handleAnalyticsMessageInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleAnalyticsMessage(handleAnalyticsMessageInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.handleAnalyticsMessage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {HandleClientConnectedInput} [handleClientConnectedInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleClientConnected: function (confirmationToken, iotKey, handleClientConnectedInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleClientConnected(confirmationToken, iotKey, handleClientConnectedInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.handleClientConnected']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<HandleQuickbooksWebhookRequestInner>} handleQuickbooksWebhookRequestInner
         * @param {string} [intuitSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQuickbooksWebhook: function (handleQuickbooksWebhookRequestInner, intuitSignature, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleQuickbooksWebhook(handleQuickbooksWebhookRequestInner, intuitSignature, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.handleQuickbooksWebhook']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} apiKey
         * @param {NotifyExternalAlertInput} [notifyExternalAlertInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyExternalAlert: function (apiKey, notifyExternalAlertInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.notifyExternalAlert(apiKey, notifyExternalAlertInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.notifyExternalAlert']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.DefaultApiFp(configuration);
    return {
        /**
         *
         * @param {HandleAnalyticsMessageInput} [handleAnalyticsMessageInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleAnalyticsMessage: function (handleAnalyticsMessageInput, options) {
            return localVarFp.handleAnalyticsMessage(handleAnalyticsMessageInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {HandleClientConnectedInput} [handleClientConnectedInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleClientConnected: function (confirmationToken, iotKey, handleClientConnectedInput, options) {
            return localVarFp.handleClientConnected(confirmationToken, iotKey, handleClientConnectedInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<HandleQuickbooksWebhookRequestInner>} handleQuickbooksWebhookRequestInner
         * @param {string} [intuitSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQuickbooksWebhook: function (handleQuickbooksWebhookRequestInner, intuitSignature, options) {
            return localVarFp.handleQuickbooksWebhook(handleQuickbooksWebhookRequestInner, intuitSignature, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} apiKey
         * @param {NotifyExternalAlertInput} [notifyExternalAlertInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyExternalAlert: function (apiKey, notifyExternalAlertInput, options) {
            return localVarFp.notifyExternalAlert(apiKey, notifyExternalAlertInput, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {HandleAnalyticsMessageInput} [handleAnalyticsMessageInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DefaultApi.prototype.handleAnalyticsMessage = function (handleAnalyticsMessageInput, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).handleAnalyticsMessage(handleAnalyticsMessageInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [confirmationToken]
     * @param {string} [iotKey]
     * @param {HandleClientConnectedInput} [handleClientConnectedInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DefaultApi.prototype.handleClientConnected = function (confirmationToken, iotKey, handleClientConnectedInput, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).handleClientConnected(confirmationToken, iotKey, handleClientConnectedInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<HandleQuickbooksWebhookRequestInner>} handleQuickbooksWebhookRequestInner
     * @param {string} [intuitSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DefaultApi.prototype.handleQuickbooksWebhook = function (handleQuickbooksWebhookRequestInner, intuitSignature, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).handleQuickbooksWebhook(handleQuickbooksWebhookRequestInner, intuitSignature, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} apiKey
     * @param {NotifyExternalAlertInput} [notifyExternalAlertInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DefaultApi.prototype.notifyExternalAlert = function (apiKey, notifyExternalAlertInput, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).notifyExternalAlert(apiKey, notifyExternalAlertInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
/**
 * DevicesApi - axios parameter creator
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} thingName
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPairedDevice: function (thingName, token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'thingName' is not null or undefined
                            common_1.assertParamExists('checkPairedDevice', 'thingName', thingName);
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('checkPairedDevice', 'token', token);
                            localVarPath = "/devices/{thingName}/pairing-status"
                                .replace('{thingName}', encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkValidDevices: function (unids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'unids' is not null or undefined
                            common_1.assertParamExists('checkValidDevices', 'unids', unids);
                            localVarPath = "/devices/valid";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            if (unids !== undefined) {
                                localVarQueryParameter['unids'] = unids;
                            }
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} firmwareVersion
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePairingTokens: function (firmwareVersion, token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'firmwareVersion' is not null or undefined
                            common_1.assertParamExists('getDevicePairingTokens', 'firmwareVersion', firmwareVersion);
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('getDevicePairingTokens', 'token', token);
                            localVarPath = "/devices/pairing-tokens/{firmwareVersion}"
                                .replace('{firmwareVersion}', encodeURIComponent(String(firmwareVersion)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {HandleJobExecutionCompletedInput} [handleJobExecutionCompletedInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleJobExecutionCompleted: function (confirmationToken, iotKey, handleJobExecutionCompletedInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/devices/job-execution-completed";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (confirmationToken !== undefined) {
                        localVarQueryParameter['confirmationToken'] = confirmationToken;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (iotKey != null) {
                        localVarHeaderParameter['iotKey'] = String(iotKey);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(handleJobExecutionCompletedInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.DevicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} thingName
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPairedDevice: function (thingName, token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkPairedDevice(thingName, token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.checkPairedDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkValidDevices: function (unids, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkValidDevices(unids, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.checkValidDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} firmwareVersion
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePairingTokens: function (firmwareVersion, token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevicePairingTokens(firmwareVersion, token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.getDevicePairingTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {HandleJobExecutionCompletedInput} [handleJobExecutionCompletedInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleJobExecutionCompleted: function (confirmationToken, iotKey, handleJobExecutionCompletedInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleJobExecutionCompleted(confirmationToken, iotKey, handleJobExecutionCompletedInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.handleJobExecutionCompleted']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.DevicesApiFp(configuration);
    return {
        /**
         *
         * @param {string} thingName
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPairedDevice: function (thingName, token, options) {
            return localVarFp.checkPairedDevice(thingName, token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkValidDevices: function (unids, options) {
            return localVarFp.checkValidDevices(unids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} firmwareVersion
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePairingTokens: function (firmwareVersion, token, options) {
            return localVarFp.getDevicePairingTokens(firmwareVersion, token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {HandleJobExecutionCompletedInput} [handleJobExecutionCompletedInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleJobExecutionCompleted: function (confirmationToken, iotKey, handleJobExecutionCompletedInput, options) {
            return localVarFp.handleJobExecutionCompleted(confirmationToken, iotKey, handleJobExecutionCompletedInput, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} thingName
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DevicesApi.prototype.checkPairedDevice = function (thingName, token, options) {
        var _this = this;
        return exports.DevicesApiFp(this.configuration).checkPairedDevice(thingName, token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DevicesApi.prototype.checkValidDevices = function (unids, options) {
        var _this = this;
        return exports.DevicesApiFp(this.configuration).checkValidDevices(unids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} firmwareVersion
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DevicesApi.prototype.getDevicePairingTokens = function (firmwareVersion, token, options) {
        var _this = this;
        return exports.DevicesApiFp(this.configuration).getDevicePairingTokens(firmwareVersion, token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [confirmationToken]
     * @param {string} [iotKey]
     * @param {HandleJobExecutionCompletedInput} [handleJobExecutionCompletedInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    DevicesApi.prototype.handleJobExecutionCompleted = function (confirmationToken, iotKey, handleJobExecutionCompletedInput, options) {
        var _this = this;
        return exports.DevicesApiFp(this.configuration).handleJobExecutionCompleted(confirmationToken, iotKey, handleJobExecutionCompletedInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * FleetManagementSystemApi - axios parameter creator
 */
var FleetManagementSystemApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} unid
         * @param {AddAllowedSerialNumbersInput} [addAllowedSerialNumbersInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllowedSerialNumbers: function (unid, addAllowedSerialNumbersInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('addAllowedSerialNumbers', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/allowed-serial-numbers"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(addAllowedSerialNumbersInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AddUnitToFleetInput} [addUnitToFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnitToFleet: function (unid, addUnitToFleetInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('addUnitToFleet', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(addUnitToFleetInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivateFMSCustomer: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminActivateFMSCustomer', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/activate"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminCreateFMSCustomerUserInput} [adminCreateFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFMSCustomerUser: function (unid, adminCreateFMSCustomerUserInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminCreateFMSCustomerUser', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCreateFMSCustomerUserInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCustomerUser: function (unid, userUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminDeleteCustomerUser', 'unid', unid);
                    // verify required parameter 'userUnid' is not null or undefined
                    common_1.assertParamExists('adminDeleteCustomerUser', 'userUnid', userUnid);
                    localVarPath = "/fms/customers/{unid}/users/{userUnid}"
                        .replace('{unid}', encodeURIComponent(String(unid)))
                        .replace('{userUnid}', encodeURIComponent(String(userUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {boolean | null} [isOverdue]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfCustomerLicenseInvoices: function (unid, pageNumber, isOverdue, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminFetchPageOfCustomerLicenseInvoices', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminFetchPageOfCustomerLicenseInvoices', 'pageNumber', pageNumber);
                    localVarPath = "/fms/customers/{unid}/invoices"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (isOverdue !== undefined) {
                        localVarQueryParameter['isOverdue'] = isOverdue;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfCustomerUsers: function (unid, pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminFetchPageOfCustomerUsers', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('adminFetchPageOfCustomerUsers', 'pageNumber', pageNumber);
                    localVarPath = "/fms/customers/{unid}/users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCustomerUser: function (unid, userUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminGetCustomerUser', 'unid', unid);
                    // verify required parameter 'userUnid' is not null or undefined
                    common_1.assertParamExists('adminGetCustomerUser', 'userUnid', userUnid);
                    localVarPath = "/fms/customers/{unid}/users/{userUnid}"
                        .replace('{unid}', encodeURIComponent(String(unid)))
                        .replace('{userUnid}', encodeURIComponent(String(userUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveAllowedSerialNumber: function (serialNumber, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('adminRemoveAllowedSerialNumber', 'serialNumber', serialNumber);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('adminRemoveAllowedSerialNumber', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/allowed-serial-numbers/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {BulkAddUnitsToFleetInput} [bulkAddUnitsToFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddUnitsToFleet: function (unid, bulkAddUnitsToFleetInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('bulkAddUnitsToFleet', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units/bulk"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bulkAddUnitsToFleetInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CreateAuditTrailReportInput} [createAuditTrailReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuditTrailReport: function (createAuditTrailReportInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/customers/audit-trail-reports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAuditTrailReportInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateBuildingInput} [createBuildingInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuilding: function (unid, createBuildingInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('createBuilding', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}/buildings"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createBuildingInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CreateFMSCustomerInput} [createFMSCustomerInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSCustomer: function (createFMSCustomerInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/customers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFMSCustomerInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CreateFMSCustomerUserInput} [createFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSCustomerUser: function (createFMSCustomerUserInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFMSCustomerUserInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CreateFMSNotificationInput} [createFMSNotificationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSNotification: function (createFMSNotificationInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/notifications";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFMSNotificationInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CreateFleetInput} [createFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleet: function (createFleetInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/fleets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFleetInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateFleetCSVReportInput} [createFleetCSVReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleetCSVReport: function (unid, createFleetCSVReportInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('createFleetCSVReport', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/csv-reports"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFleetCSVReportInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateFleetReportInput} [createFleetReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleetReport: function (unid, createFleetReportInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('createFleetReport', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/reports"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFleetReportInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {CreatePropertyInput} [createPropertyInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProperty: function (createPropertyInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/properties";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPropertyInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {boolean | null} [isOverdue]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerUserFetchPageOfCustomerLicenseInvoices: function (pageNumber, isOverdue, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('customerUserFetchPageOfCustomerLicenseInvoices', 'pageNumber', pageNumber);
                    localVarPath = "/fms/invoices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (isOverdue !== undefined) {
                        localVarQueryParameter['isOverdue'] = isOverdue;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuilding: function (buildingUnid, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'buildingUnid' is not null or undefined
                    common_1.assertParamExists('deleteBuilding', 'buildingUnid', buildingUnid);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteBuilding', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}/buildings/{buildingUnid}"
                        .replace('{buildingUnid}', encodeURIComponent(String(buildingUnid)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerElectricRate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/electric-rate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSCustomer: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteFMSCustomer', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSCustomerUser: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteFMSCustomerUser', 'unid', unid);
                    localVarPath = "/fms/users/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSNotification: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteFMSNotification', 'unid', unid);
                    localVarPath = "/fms/notifications/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleet: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteFleet', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetSchedule: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteFleetSchedule', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/schedule"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('deleteProperty', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {FMSCreateGradientAdminInput} [fMSCreateGradientAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSCreateGradientAdmin: function (fMSCreateGradientAdminInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/gradient-admins";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(fMSCreateGradientAdminInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {FMSForgotPasswordInput} [fMSForgotPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSForgotPassword: function (fMSForgotPasswordInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/forgot-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(fMSForgotPasswordInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSGetSelf: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/users/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSGetSyncJobStatus: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fMSGetSyncJobStatus', 'unid', unid);
                    localVarPath = "/fms/sync-jobs/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {FMSLoginInput} [fMSLoginInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSLogin: function (fMSLoginInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(fMSLoginInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSLogout: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {FMSUpdateSelfInput} [fMSUpdateSelfInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSUpdateSelf: function (fMSUpdateSelfInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/users/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(fMSUpdateSelfInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [serialNumberFragment] If provided, only serial numbers containing this fragment will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfAllowedSerialNumbers: function (unid, pageNumber, pageSize, serialNumberFragment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fetchPageOfAllowedSerialNumbers', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfAllowedSerialNumbers', 'pageNumber', pageNumber);
                    localVarPath = "/fms/customers/{unid}/allowed-serial-numbers"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (serialNumberFragment !== undefined) {
                        localVarQueryParameter['serialNumberFragment'] = serialNumberFragment;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
         * @param {string | null} [belongsToFleet] If provided, only units that belong to a fleet or do not belong to a fleet will be returned
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfCustomerUnits: function (pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfCustomerUnits', 'pageNumber', pageNumber);
                    localVarPath = "/fms/units";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (activated !== undefined) {
                        localVarQueryParameter['activated'] = activated;
                    }
                    if (belongsToFleet !== undefined) {
                        localVarQueryParameter['belongsToFleet'] = belongsToFleet;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortDirection !== undefined) {
                        localVarQueryParameter['sortDirection'] = sortDirection;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSCustomerUsers: function (pageNumber, pageSize, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFMSCustomerUsers', 'pageNumber', pageNumber);
                    localVarPath = "/fms/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSCustomers: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFMSCustomers', 'pageNumber', pageNumber);
                    localVarPath = "/fms/customers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSNotifications: function (pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFMSNotifications', 'pageNumber', pageNumber);
                    localVarPath = "/fms/notifications";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetAlerts: function (unid, pageNumber, pageSize, search, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetAlerts', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetAlerts', 'pageNumber', pageNumber);
                    localVarPath = "/fms/fleets/{unid}/alerts"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetStatusCheckJobs: function (unid, pageNumber, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetStatusCheckJobs', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetStatusCheckJobs', 'pageNumber', pageNumber);
                    localVarPath = "/fms/fleets/{unid}/status-checks"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {FetchPageOfFleetTopUsersTimePeriodEnum} timePeriod
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetTopUsers: function (unid, pageNumber, timePeriod, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetTopUsers', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetTopUsers', 'pageNumber', pageNumber);
                    // verify required parameter 'timePeriod' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetTopUsers', 'timePeriod', timePeriod);
                    localVarPath = "/fms/fleets/{unid}/top-energy-users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (timePeriod !== undefined) {
                        localVarQueryParameter['timePeriod'] = timePeriod;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {string | null} [connected]
         * @param {number | null} [pageSize]
         * @param {string | null} [running]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetUnits: function (unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetUnits', 'unid', unid);
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleetUnits', 'pageNumber', pageNumber);
                    localVarPath = "/fms/fleets/{unid}/units"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (connected !== undefined) {
                        localVarQueryParameter['connected'] = connected;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (running !== undefined) {
                        localVarQueryParameter['running'] = running;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortDirection !== undefined) {
                        localVarQueryParameter['sortDirection'] = sortDirection;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleets: function (pageNumber, pageSize, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfFleets', 'pageNumber', pageNumber);
                    localVarPath = "/fms/fleets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [nameFragment]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfProperties: function (pageNumber, nameFragment, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfProperties', 'pageNumber', pageNumber);
                    localVarPath = "/fms/properties";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (nameFragment !== undefined) {
                        localVarQueryParameter['nameFragment'] = nameFragment;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfUnassociatedUnits: function (pageNumber, activated, pageSize, search, sortBy, sortDirection, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pageNumber' is not null or undefined
                    common_1.assertParamExists('fetchPageOfUnassociatedUnits', 'pageNumber', pageNumber);
                    localVarPath = "/fms/unassociated-units";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (activated !== undefined) {
                        localVarQueryParameter['activated'] = activated;
                    }
                    if (pageNumber !== undefined) {
                        localVarQueryParameter['pageNumber'] = pageNumber;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortDirection !== undefined) {
                        localVarQueryParameter['sortDirection'] = sortDirection;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersAuditTrailReportsIdOptions: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('fmsCustomersAuditTrailReportsIdOptions', 'id', id);
                    localVarPath = "/fms/customers/audit-trail-reports/{id}"
                        .replace('{id}', encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersAuditTrailReportsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/customers/audit-trail-reports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/customers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidActivateOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidActivateOptions', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/activate"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidAllowedSerialNumbersOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidAllowedSerialNumbersOptions', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/allowed-serial-numbers"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions: function (serialNumber, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions', 'serialNumber', serialNumber);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/allowed-serial-numbers/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidInvoicesOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidInvoicesOptions', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/invoices"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidOptions', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidUsersOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidUsersOptions', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}/users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidUsersUserUnidOptions: function (unid, userUnid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidUsersUserUnidOptions', 'unid', unid);
                    // verify required parameter 'userUnid' is not null or undefined
                    common_1.assertParamExists('fmsCustomersUnidUsersUserUnidOptions', 'userUnid', userUnid);
                    localVarPath = "/fms/customers/{unid}/users/{userUnid}"
                        .replace('{unid}', encodeURIComponent(String(unid)))
                        .replace('{userUnid}', encodeURIComponent(String(userUnid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsElectricRateOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/electric-rate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsElectricRateOptionsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/electric-rate-options";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/fleets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidAlertsOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidAlertsOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/alerts"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidControlValuesOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidControlValuesOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/control-values"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCsvReportsIdOptions: function (id, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidCsvReportsIdOptions', 'id', id);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidCsvReportsIdOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/csv-reports/{id}"
                        .replace('{id}', encodeURIComponent(String(id)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCsvReportsOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidCsvReportsOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/csv-reports"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCurrentLimitOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidCurrentLimitOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/current-limit"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidElectricRateOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidElectricRateOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/electric-rate"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidEnergyUsageOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidEnergyUsageOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/energy-usage"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidLimitsOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidLimitsOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/limits"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidReportsIdOptions: function (id, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidReportsIdOptions', 'id', id);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidReportsIdOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/reports/{id}"
                        .replace('{id}', encodeURIComponent(String(id)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidReportsOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidReportsOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/reports"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidScheduleOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidScheduleOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/schedule"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidStatusChecksJobIdOptions: function (jobId, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jobId' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidStatusChecksJobIdOptions', 'jobId', jobId);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidStatusChecksJobIdOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/status-checks/{jobId}"
                        .replace('{jobId}', encodeURIComponent(String(jobId)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidStatusChecksOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidStatusChecksOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/status-checks"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidTopEnergyUsersOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidTopEnergyUsersOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/top-energy-users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidTopUsersOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidTopUsersOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/top-users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsBulkOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidUnitsBulkOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units/bulk"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidUnitsOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsSerialNumberOptions: function (serialNumber, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidUnitsSerialNumberOptions', 'serialNumber', serialNumber);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsFleetsUnidUnitsSerialNumberOptions', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsForgotPasswordOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/forgot-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsGradientAdminsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/gradient-admins";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsInvoicesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/invoices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsLoginOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsLogoutOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/notifications";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsNotificationsUnidOptions', 'unid', unid);
                    localVarPath = "/fms/notifications/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsUnidViewOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsNotificationsUnidViewOptions', 'unid', unid);
                    localVarPath = "/fms/notifications/{unid}/view"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/properties";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidBuildingsBuildingUnidOptions: function (buildingUnid, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'buildingUnid' is not null or undefined
                    common_1.assertParamExists('fmsPropertiesUnidBuildingsBuildingUnidOptions', 'buildingUnid', buildingUnid);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsPropertiesUnidBuildingsBuildingUnidOptions', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}/buildings/{buildingUnid}"
                        .replace('{buildingUnid}', encodeURIComponent(String(buildingUnid)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidBuildingsOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsPropertiesUnidBuildingsOptions', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}/buildings"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsPropertiesUnidOptions', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsSyncJobsUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsSyncJobsUnidOptions', 'unid', unid);
                    localVarPath = "/fms/sync-jobs/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnassociatedUnitsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/unassociated-units";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnassociatedUnitsSerialNumberOptions: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('fmsUnassociatedUnitsSerialNumberOptions', 'serialNumber', serialNumber);
                    localVarPath = "/fms/unassociated-units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnitsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/units";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersMeOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/users/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersUnidOptions: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('fmsUsersUnidOptions', 'unid', unid);
                    localVarPath = "/fms/users/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailReportStatus: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('getAuditTrailReportStatus', 'id', id);
                    localVarPath = "/fms/customers/audit-trail-reports/{id}"
                        .replace('{id}', encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuilding: function (buildingUnid, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'buildingUnid' is not null or undefined
                    common_1.assertParamExists('getBuilding', 'buildingUnid', buildingUnid);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getBuilding', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}/buildings/{buildingUnid}"
                        .replace('{buildingUnid}', encodeURIComponent(String(buildingUnid)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElectricRateOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/electric-rate-options";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSCustomer: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFMSCustomer', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSCustomerUser: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFMSCustomerUser', 'unid', unid);
                    localVarPath = "/fms/users/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSNotification: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFMSNotification', 'unid', unid);
                    localVarPath = "/fms/notifications/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleet: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleet', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetCSVReportStatus: function (id, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('getFleetCSVReportStatus', 'id', id);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetCSVReportStatus', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/csv-reports/{id}"
                        .replace('{id}', encodeURIComponent(String(id)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetControlValues: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetControlValues', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/control-values"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetCurrentLimit: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetCurrentLimit', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/current-limit"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetElectricRate: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetElectricRate', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/electric-rate"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetEnergyUsage: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetEnergyUsage', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/energy-usage"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLimits: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetLimits', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/limits"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetReportStatus: function (id, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('getFleetReportStatus', 'id', id);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetReportStatus', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/reports/{id}"
                        .replace('{id}', encodeURIComponent(String(id)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetSchedule: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetSchedule', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/schedule"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {string} unid
         * @param {Array<string>} [watchedSerialNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetStatusCheckJob: function (jobId, unid, watchedSerialNumbers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'jobId' is not null or undefined
                    common_1.assertParamExists('getFleetStatusCheckJob', 'jobId', jobId);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetStatusCheckJob', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/status-checks/{jobId}"
                        .replace('{jobId}', encodeURIComponent(String(jobId)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (watchedSerialNumbers) {
                        localVarQueryParameter['watchedSerialNumbers'] = watchedSerialNumbers;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetTopUsers: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetTopUsers', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/top-users"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetUnit: function (serialNumber, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('getFleetUnit', 'serialNumber', serialNumber);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getFleetUnit', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('getProperty', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassociatedUnit: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('getUnassociatedUnit', 'serialNumber', serialNumber);
                    localVarPath = "/fms/unassociated-units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFleetUnit: function (serialNumber, unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('removeFleetUnit', 'serialNumber', serialNumber);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('removeFleetUnit', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFleetStatusCheck: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('startFleetStatusCheck', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/status-checks"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {UpdateBuildingInput} [updateBuildingInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuilding: function (buildingUnid, unid, updateBuildingInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'buildingUnid' is not null or undefined
                    common_1.assertParamExists('updateBuilding', 'buildingUnid', buildingUnid);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateBuilding', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}/buildings/{buildingUnid}"
                        .replace('{buildingUnid}', encodeURIComponent(String(buildingUnid)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateBuildingInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {UpdateCustomerElectricRateInput} [updateCustomerElectricRateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerElectricRate: function (updateCustomerElectricRateInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fms/electric-rate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCustomerElectricRateInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSCustomerInput} [updateFMSCustomerInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSCustomer: function (unid, updateFMSCustomerInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFMSCustomer', 'unid', unid);
                    localVarPath = "/fms/customers/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFMSCustomerInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSCustomerUserInput} [updateFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSCustomerUser: function (unid, updateFMSCustomerUserInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFMSCustomerUser', 'unid', unid);
                    localVarPath = "/fms/users/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFMSCustomerUserInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSNotificationInput} [updateFMSNotificationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSNotification: function (unid, updateFMSNotificationInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFMSNotification', 'unid', unid);
                    localVarPath = "/fms/notifications/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFMSNotificationInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetInput} [updateFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleet: function (unid, updateFleetInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleet', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetControlValuesInput} [updateFleetControlValuesInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetControlValues: function (unid, updateFleetControlValuesInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleetControlValues', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/control-values"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetControlValuesInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetCurrentLimitInput} [updateFleetCurrentLimitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetCurrentLimit: function (unid, updateFleetCurrentLimitInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleetCurrentLimit', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/current-limit"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetCurrentLimitInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetElectricRateInput} [updateFleetElectricRateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetElectricRate: function (unid, updateFleetElectricRateInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleetElectricRate', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/electric-rate"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetElectricRateInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetLimitsInput} [updateFleetLimitsInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetLimits: function (unid, updateFleetLimitsInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleetLimits', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/limits"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetLimitsInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetScheduleInput} [updateFleetScheduleInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetSchedule: function (unid, updateFleetScheduleInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleetSchedule', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/schedule"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetScheduleInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {UpdateFleetUnitInput} [updateFleetUnitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetUnit: function (serialNumber, unid, updateFleetUnitInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('updateFleetUnit', 'serialNumber', serialNumber);
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateFleetUnit', 'unid', unid);
                    localVarPath = "/fms/fleets/{unid}/units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)))
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFleetUnitInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdatePropertyInput} [updatePropertyInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProperty: function (unid, updatePropertyInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('updateProperty', 'unid', unid);
                    localVarPath = "/fms/properties/{unid}"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePropertyInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {UpdateUnassociatedUnitInput} [updateUnassociatedUnitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnassociatedUnit: function (serialNumber, updateUnassociatedUnitInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    common_1.assertParamExists('updateUnassociatedUnit', 'serialNumber', serialNumber);
                    localVarPath = "/fms/unassociated-units/{serialNumber}"
                        .replace('{serialNumber}', encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateUnassociatedUnitInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFMSNotification: function (unid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'unid' is not null or undefined
                    common_1.assertParamExists('viewFMSNotification', 'unid', unid);
                    localVarPath = "/fms/notifications/{unid}/view"
                        .replace('{unid}', encodeURIComponent(String(unid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FleetManagementSystemApiAxiosParamCreator = FleetManagementSystemApiAxiosParamCreator;
/**
 * FleetManagementSystemApi - functional programming interface
 */
var FleetManagementSystemApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.FleetManagementSystemApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} unid
         * @param {AddAllowedSerialNumbersInput} [addAllowedSerialNumbersInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllowedSerialNumbers: function (unid, addAllowedSerialNumbersInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addAllowedSerialNumbers(unid, addAllowedSerialNumbersInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.addAllowedSerialNumbers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AddUnitToFleetInput} [addUnitToFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnitToFleet: function (unid, addUnitToFleetInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUnitToFleet(unid, addUnitToFleetInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.addUnitToFleet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivateFMSCustomer: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminActivateFMSCustomer(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminActivateFMSCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminCreateFMSCustomerUserInput} [adminCreateFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFMSCustomerUser: function (unid, adminCreateFMSCustomerUserInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateFMSCustomerUser(unid, adminCreateFMSCustomerUserInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminCreateFMSCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCustomerUser: function (unid, userUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteCustomerUser(unid, userUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminDeleteCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {boolean | null} [isOverdue]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfCustomerLicenseInvoices: function (unid, pageNumber, isOverdue, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminFetchPageOfCustomerLicenseInvoices(unid, pageNumber, isOverdue, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminFetchPageOfCustomerLicenseInvoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfCustomerUsers: function (unid, pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminFetchPageOfCustomerUsers(unid, pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminFetchPageOfCustomerUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCustomerUser: function (unid, userUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetCustomerUser(unid, userUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminGetCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveAllowedSerialNumber: function (serialNumber, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminRemoveAllowedSerialNumber(serialNumber, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.adminRemoveAllowedSerialNumber']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {BulkAddUnitsToFleetInput} [bulkAddUnitsToFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddUnitsToFleet: function (unid, bulkAddUnitsToFleetInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkAddUnitsToFleet(unid, bulkAddUnitsToFleetInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.bulkAddUnitsToFleet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateAuditTrailReportInput} [createAuditTrailReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuditTrailReport: function (createAuditTrailReportInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAuditTrailReport(createAuditTrailReportInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createAuditTrailReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateBuildingInput} [createBuildingInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuilding: function (unid, createBuildingInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBuilding(unid, createBuildingInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createBuilding']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateFMSCustomerInput} [createFMSCustomerInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSCustomer: function (createFMSCustomerInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFMSCustomer(createFMSCustomerInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createFMSCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateFMSCustomerUserInput} [createFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSCustomerUser: function (createFMSCustomerUserInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFMSCustomerUser(createFMSCustomerUserInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createFMSCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateFMSNotificationInput} [createFMSNotificationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSNotification: function (createFMSNotificationInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFMSNotification(createFMSNotificationInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createFMSNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateFleetInput} [createFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleet: function (createFleetInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFleet(createFleetInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createFleet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateFleetCSVReportInput} [createFleetCSVReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleetCSVReport: function (unid, createFleetCSVReportInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFleetCSVReport(unid, createFleetCSVReportInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createFleetCSVReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateFleetReportInput} [createFleetReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleetReport: function (unid, createFleetReportInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFleetReport(unid, createFleetReportInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createFleetReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreatePropertyInput} [createPropertyInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProperty: function (createPropertyInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProperty(createPropertyInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.createProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {boolean | null} [isOverdue]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerUserFetchPageOfCustomerLicenseInvoices: function (pageNumber, isOverdue, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerUserFetchPageOfCustomerLicenseInvoices(pageNumber, isOverdue, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.customerUserFetchPageOfCustomerLicenseInvoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuilding: function (buildingUnid, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBuilding(buildingUnid, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteBuilding']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerElectricRate: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCustomerElectricRate(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteCustomerElectricRate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSCustomer: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFMSCustomer(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteFMSCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSCustomerUser: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFMSCustomerUser(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteFMSCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSNotification: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFMSNotification(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteFMSNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleet: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFleet(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteFleet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetSchedule: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFleetSchedule(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteFleetSchedule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProperty(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.deleteProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {FMSCreateGradientAdminInput} [fMSCreateGradientAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSCreateGradientAdmin: function (fMSCreateGradientAdminInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSCreateGradientAdmin(fMSCreateGradientAdminInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSCreateGradientAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {FMSForgotPasswordInput} [fMSForgotPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSForgotPassword: function (fMSForgotPasswordInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSForgotPassword(fMSForgotPasswordInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSForgotPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSGetSelf: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSGetSelf(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSGetSelf']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSGetSyncJobStatus: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSGetSyncJobStatus(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSGetSyncJobStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {FMSLoginInput} [fMSLoginInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSLogin: function (fMSLoginInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSLogin(fMSLoginInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSLogin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSLogout: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSLogout(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSLogout']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {FMSUpdateSelfInput} [fMSUpdateSelfInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSUpdateSelf: function (fMSUpdateSelfInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fMSUpdateSelf(fMSUpdateSelfInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fMSUpdateSelf']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [serialNumberFragment] If provided, only serial numbers containing this fragment will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfAllowedSerialNumbers: function (unid, pageNumber, pageSize, serialNumberFragment, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfAllowedSerialNumbers(unid, pageNumber, pageSize, serialNumberFragment, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfAllowedSerialNumbers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
         * @param {string | null} [belongsToFleet] If provided, only units that belong to a fleet or do not belong to a fleet will be returned
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfCustomerUnits: function (pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfCustomerUnits(pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfCustomerUnits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSCustomerUsers: function (pageNumber, pageSize, search, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFMSCustomerUsers(pageNumber, pageSize, search, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFMSCustomerUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSCustomers: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFMSCustomers(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFMSCustomers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSNotifications: function (pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFMSNotifications(pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFMSNotifications']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetAlerts: function (unid, pageNumber, pageSize, search, status, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFleetAlerts(unid, pageNumber, pageSize, search, status, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFleetAlerts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetStatusCheckJobs: function (unid, pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFleetStatusCheckJobs(unid, pageNumber, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFleetStatusCheckJobs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {FetchPageOfFleetTopUsersTimePeriodEnum} timePeriod
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetTopUsers: function (unid, pageNumber, timePeriod, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFleetTopUsers(unid, pageNumber, timePeriod, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFleetTopUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {string | null} [connected]
         * @param {number | null} [pageSize]
         * @param {string | null} [running]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetUnits: function (unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFleetUnits(unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFleetUnits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleets: function (pageNumber, pageSize, search, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfFleets(pageNumber, pageSize, search, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfFleets']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [nameFragment]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfProperties: function (pageNumber, nameFragment, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfProperties(pageNumber, nameFragment, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfUnassociatedUnits: function (pageNumber, activated, pageSize, search, sortBy, sortDirection, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchPageOfUnassociatedUnits(pageNumber, activated, pageSize, search, sortBy, sortDirection, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fetchPageOfUnassociatedUnits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersAuditTrailReportsIdOptions: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersAuditTrailReportsIdOptions(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersAuditTrailReportsIdOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersAuditTrailReportsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersAuditTrailReportsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersAuditTrailReportsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidActivateOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidActivateOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidActivateOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidAllowedSerialNumbersOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidAllowedSerialNumbersOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidAllowedSerialNumbersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions: function (serialNumber, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions(serialNumber, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidInvoicesOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidInvoicesOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidInvoicesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidUsersOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidUsersOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidUsersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidUsersUserUnidOptions: function (unid, userUnid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsCustomersUnidUsersUserUnidOptions(unid, userUnid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsCustomersUnidUsersUserUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsElectricRateOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsElectricRateOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsElectricRateOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsElectricRateOptionsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsElectricRateOptionsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsElectricRateOptionsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidAlertsOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidAlertsOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidAlertsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidControlValuesOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidControlValuesOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidControlValuesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCsvReportsIdOptions: function (id, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidCsvReportsIdOptions(id, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidCsvReportsIdOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCsvReportsOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidCsvReportsOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidCsvReportsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCurrentLimitOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidCurrentLimitOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidCurrentLimitOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidElectricRateOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidElectricRateOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidElectricRateOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidEnergyUsageOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidEnergyUsageOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidEnergyUsageOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidLimitsOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidLimitsOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidLimitsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidReportsIdOptions: function (id, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidReportsIdOptions(id, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidReportsIdOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidReportsOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidReportsOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidReportsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidScheduleOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidScheduleOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidScheduleOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidStatusChecksJobIdOptions: function (jobId, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidStatusChecksJobIdOptions(jobId, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidStatusChecksJobIdOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidStatusChecksOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidStatusChecksOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidStatusChecksOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidTopEnergyUsersOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidTopEnergyUsersOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidTopEnergyUsersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidTopUsersOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidTopUsersOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidTopUsersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsBulkOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidUnitsBulkOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidUnitsBulkOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidUnitsOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidUnitsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsSerialNumberOptions: function (serialNumber, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsFleetsUnidUnitsSerialNumberOptions(serialNumber, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsFleetsUnidUnitsSerialNumberOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsForgotPasswordOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsForgotPasswordOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsForgotPasswordOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsGradientAdminsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsGradientAdminsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsGradientAdminsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsInvoicesOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsInvoicesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsInvoicesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsLoginOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsLoginOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsLoginOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsLogoutOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsLogoutOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsLogoutOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsNotificationsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsNotificationsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsNotificationsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsNotificationsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsUnidViewOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsNotificationsUnidViewOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsNotificationsUnidViewOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsPropertiesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsPropertiesOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidBuildingsBuildingUnidOptions: function (buildingUnid, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsPropertiesUnidBuildingsBuildingUnidOptions(buildingUnid, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsPropertiesUnidBuildingsBuildingUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidBuildingsOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsPropertiesUnidBuildingsOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsPropertiesUnidBuildingsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsPropertiesUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsPropertiesUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsSyncJobsUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsSyncJobsUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsSyncJobsUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnassociatedUnitsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsUnassociatedUnitsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsUnassociatedUnitsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnassociatedUnitsSerialNumberOptions: function (serialNumber, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsUnassociatedUnitsSerialNumberOptions(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsUnassociatedUnitsSerialNumberOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnitsOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsUnitsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsUnitsOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersMeOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsUsersMeOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsUsersMeOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsUsersOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsUsersOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersUnidOptions: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmsUsersUnidOptions(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.fmsUsersUnidOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailReportStatus: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuditTrailReportStatus(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getAuditTrailReportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuilding: function (buildingUnid, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBuilding(buildingUnid, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getBuilding']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElectricRateOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getElectricRateOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getElectricRateOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSCustomer: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFMSCustomer(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFMSCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSCustomerUser: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFMSCustomerUser(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFMSCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSNotification: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFMSNotification(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFMSNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleet: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleet(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetCSVReportStatus: function (id, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetCSVReportStatus(id, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetCSVReportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetControlValues: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetControlValues(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetControlValues']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetCurrentLimit: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetCurrentLimit(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetCurrentLimit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetElectricRate: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetElectricRate(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetElectricRate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetEnergyUsage: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetEnergyUsage(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetEnergyUsage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLimits: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetLimits(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetLimits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetReportStatus: function (id, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetReportStatus(id, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetReportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetSchedule: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetSchedule(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetSchedule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {string} unid
         * @param {Array<string>} [watchedSerialNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetStatusCheckJob: function (jobId, unid, watchedSerialNumbers, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetStatusCheckJob(jobId, unid, watchedSerialNumbers, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetStatusCheckJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetTopUsers: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetTopUsers(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetTopUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetUnit: function (serialNumber, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetUnit(serialNumber, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getFleetUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProperty(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassociatedUnit: function (serialNumber, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUnassociatedUnit(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.getUnassociatedUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFleetUnit: function (serialNumber, unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeFleetUnit(serialNumber, unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.removeFleetUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFleetStatusCheck: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.startFleetStatusCheck(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.startFleetStatusCheck']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {UpdateBuildingInput} [updateBuildingInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuilding: function (buildingUnid, unid, updateBuildingInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBuilding(buildingUnid, unid, updateBuildingInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateBuilding']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateCustomerElectricRateInput} [updateCustomerElectricRateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerElectricRate: function (updateCustomerElectricRateInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCustomerElectricRate(updateCustomerElectricRateInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateCustomerElectricRate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSCustomerInput} [updateFMSCustomerInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSCustomer: function (unid, updateFMSCustomerInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFMSCustomer(unid, updateFMSCustomerInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFMSCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSCustomerUserInput} [updateFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSCustomerUser: function (unid, updateFMSCustomerUserInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFMSCustomerUser(unid, updateFMSCustomerUserInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFMSCustomerUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSNotificationInput} [updateFMSNotificationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSNotification: function (unid, updateFMSNotificationInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFMSNotification(unid, updateFMSNotificationInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFMSNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetInput} [updateFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleet: function (unid, updateFleetInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleet(unid, updateFleetInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetControlValuesInput} [updateFleetControlValuesInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetControlValues: function (unid, updateFleetControlValuesInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleetControlValues(unid, updateFleetControlValuesInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleetControlValues']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetCurrentLimitInput} [updateFleetCurrentLimitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetCurrentLimit: function (unid, updateFleetCurrentLimitInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleetCurrentLimit(unid, updateFleetCurrentLimitInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleetCurrentLimit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetElectricRateInput} [updateFleetElectricRateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetElectricRate: function (unid, updateFleetElectricRateInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleetElectricRate(unid, updateFleetElectricRateInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleetElectricRate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetLimitsInput} [updateFleetLimitsInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetLimits: function (unid, updateFleetLimitsInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleetLimits(unid, updateFleetLimitsInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleetLimits']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetScheduleInput} [updateFleetScheduleInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetSchedule: function (unid, updateFleetScheduleInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleetSchedule(unid, updateFleetScheduleInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleetSchedule']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {UpdateFleetUnitInput} [updateFleetUnitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetUnit: function (serialNumber, unid, updateFleetUnitInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFleetUnit(serialNumber, unid, updateFleetUnitInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateFleetUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdatePropertyInput} [updatePropertyInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProperty: function (unid, updatePropertyInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProperty(unid, updatePropertyInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {UpdateUnassociatedUnitInput} [updateUnassociatedUnitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnassociatedUnit: function (serialNumber, updateUnassociatedUnitInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUnassociatedUnit(serialNumber, updateUnassociatedUnitInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.updateUnassociatedUnit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFMSNotification: function (unid, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.viewFMSNotification(unid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FleetManagementSystemApi.viewFMSNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FleetManagementSystemApiFp = FleetManagementSystemApiFp;
/**
 * FleetManagementSystemApi - factory interface
 */
var FleetManagementSystemApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.FleetManagementSystemApiFp(configuration);
    return {
        /**
         *
         * @param {string} unid
         * @param {AddAllowedSerialNumbersInput} [addAllowedSerialNumbersInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllowedSerialNumbers: function (unid, addAllowedSerialNumbersInput, options) {
            return localVarFp.addAllowedSerialNumbers(unid, addAllowedSerialNumbersInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {AddUnitToFleetInput} [addUnitToFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnitToFleet: function (unid, addUnitToFleetInput, options) {
            return localVarFp.addUnitToFleet(unid, addUnitToFleetInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivateFMSCustomer: function (unid, options) {
            return localVarFp.adminActivateFMSCustomer(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {AdminCreateFMSCustomerUserInput} [adminCreateFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFMSCustomerUser: function (unid, adminCreateFMSCustomerUserInput, options) {
            return localVarFp.adminCreateFMSCustomerUser(unid, adminCreateFMSCustomerUserInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCustomerUser: function (unid, userUnid, options) {
            return localVarFp.adminDeleteCustomerUser(unid, userUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {boolean | null} [isOverdue]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfCustomerLicenseInvoices: function (unid, pageNumber, isOverdue, pageSize, options) {
            return localVarFp.adminFetchPageOfCustomerLicenseInvoices(unid, pageNumber, isOverdue, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchPageOfCustomerUsers: function (unid, pageNumber, pageSize, options) {
            return localVarFp.adminFetchPageOfCustomerUsers(unid, pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCustomerUser: function (unid, userUnid, options) {
            return localVarFp.adminGetCustomerUser(unid, userUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveAllowedSerialNumber: function (serialNumber, unid, options) {
            return localVarFp.adminRemoveAllowedSerialNumber(serialNumber, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {BulkAddUnitsToFleetInput} [bulkAddUnitsToFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddUnitsToFleet: function (unid, bulkAddUnitsToFleetInput, options) {
            return localVarFp.bulkAddUnitsToFleet(unid, bulkAddUnitsToFleetInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateAuditTrailReportInput} [createAuditTrailReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuditTrailReport: function (createAuditTrailReportInput, options) {
            return localVarFp.createAuditTrailReport(createAuditTrailReportInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateBuildingInput} [createBuildingInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuilding: function (unid, createBuildingInput, options) {
            return localVarFp.createBuilding(unid, createBuildingInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateFMSCustomerInput} [createFMSCustomerInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSCustomer: function (createFMSCustomerInput, options) {
            return localVarFp.createFMSCustomer(createFMSCustomerInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateFMSCustomerUserInput} [createFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSCustomerUser: function (createFMSCustomerUserInput, options) {
            return localVarFp.createFMSCustomerUser(createFMSCustomerUserInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateFMSNotificationInput} [createFMSNotificationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFMSNotification: function (createFMSNotificationInput, options) {
            return localVarFp.createFMSNotification(createFMSNotificationInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateFleetInput} [createFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleet: function (createFleetInput, options) {
            return localVarFp.createFleet(createFleetInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateFleetCSVReportInput} [createFleetCSVReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleetCSVReport: function (unid, createFleetCSVReportInput, options) {
            return localVarFp.createFleetCSVReport(unid, createFleetCSVReportInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {CreateFleetReportInput} [createFleetReportInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFleetReport: function (unid, createFleetReportInput, options) {
            return localVarFp.createFleetReport(unid, createFleetReportInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreatePropertyInput} [createPropertyInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProperty: function (createPropertyInput, options) {
            return localVarFp.createProperty(createPropertyInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {boolean | null} [isOverdue]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerUserFetchPageOfCustomerLicenseInvoices: function (pageNumber, isOverdue, pageSize, options) {
            return localVarFp.customerUserFetchPageOfCustomerLicenseInvoices(pageNumber, isOverdue, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuilding: function (buildingUnid, unid, options) {
            return localVarFp.deleteBuilding(buildingUnid, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerElectricRate: function (options) {
            return localVarFp.deleteCustomerElectricRate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSCustomer: function (unid, options) {
            return localVarFp.deleteFMSCustomer(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSCustomerUser: function (unid, options) {
            return localVarFp.deleteFMSCustomerUser(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFMSNotification: function (unid, options) {
            return localVarFp.deleteFMSNotification(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleet: function (unid, options) {
            return localVarFp.deleteFleet(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetSchedule: function (unid, options) {
            return localVarFp.deleteFleetSchedule(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: function (unid, options) {
            return localVarFp.deleteProperty(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FMSCreateGradientAdminInput} [fMSCreateGradientAdminInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSCreateGradientAdmin: function (fMSCreateGradientAdminInput, options) {
            return localVarFp.fMSCreateGradientAdmin(fMSCreateGradientAdminInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FMSForgotPasswordInput} [fMSForgotPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSForgotPassword: function (fMSForgotPasswordInput, options) {
            return localVarFp.fMSForgotPassword(fMSForgotPasswordInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSGetSelf: function (options) {
            return localVarFp.fMSGetSelf(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSGetSyncJobStatus: function (unid, options) {
            return localVarFp.fMSGetSyncJobStatus(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FMSLoginInput} [fMSLoginInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSLogin: function (fMSLoginInput, options) {
            return localVarFp.fMSLogin(fMSLoginInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSLogout: function (options) {
            return localVarFp.fMSLogout(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FMSUpdateSelfInput} [fMSUpdateSelfInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fMSUpdateSelf: function (fMSUpdateSelfInput, options) {
            return localVarFp.fMSUpdateSelf(fMSUpdateSelfInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [serialNumberFragment] If provided, only serial numbers containing this fragment will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfAllowedSerialNumbers: function (unid, pageNumber, pageSize, serialNumberFragment, options) {
            return localVarFp.fetchPageOfAllowedSerialNumbers(unid, pageNumber, pageSize, serialNumberFragment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
         * @param {string | null} [belongsToFleet] If provided, only units that belong to a fleet or do not belong to a fleet will be returned
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfCustomerUnits: function (pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options) {
            return localVarFp.fetchPageOfCustomerUnits(pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSCustomerUsers: function (pageNumber, pageSize, search, options) {
            return localVarFp.fetchPageOfFMSCustomerUsers(pageNumber, pageSize, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSCustomers: function (pageNumber, pageSize, options) {
            return localVarFp.fetchPageOfFMSCustomers(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFMSNotifications: function (pageNumber, pageSize, options) {
            return localVarFp.fetchPageOfFMSNotifications(pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetAlerts: function (unid, pageNumber, pageSize, search, status, options) {
            return localVarFp.fetchPageOfFleetAlerts(unid, pageNumber, pageSize, search, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetStatusCheckJobs: function (unid, pageNumber, pageSize, options) {
            return localVarFp.fetchPageOfFleetStatusCheckJobs(unid, pageNumber, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {FetchPageOfFleetTopUsersTimePeriodEnum} timePeriod
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetTopUsers: function (unid, pageNumber, timePeriod, pageSize, options) {
            return localVarFp.fetchPageOfFleetTopUsers(unid, pageNumber, timePeriod, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {number} pageNumber
         * @param {string | null} [connected]
         * @param {number | null} [pageSize]
         * @param {string | null} [running]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleetUnits: function (unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options) {
            return localVarFp.fetchPageOfFleetUnits(unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfFleets: function (pageNumber, pageSize, search, options) {
            return localVarFp.fetchPageOfFleets(pageNumber, pageSize, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [nameFragment]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfProperties: function (pageNumber, nameFragment, pageSize, options) {
            return localVarFp.fetchPageOfProperties(pageNumber, nameFragment, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} pageNumber
         * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
         * @param {number | null} [pageSize]
         * @param {string | null} [search]
         * @param {string | null} [sortBy]
         * @param {string | null} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPageOfUnassociatedUnits: function (pageNumber, activated, pageSize, search, sortBy, sortDirection, options) {
            return localVarFp.fetchPageOfUnassociatedUnits(pageNumber, activated, pageSize, search, sortBy, sortDirection, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersAuditTrailReportsIdOptions: function (id, options) {
            return localVarFp.fmsCustomersAuditTrailReportsIdOptions(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersAuditTrailReportsOptions: function (options) {
            return localVarFp.fmsCustomersAuditTrailReportsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersOptions: function (options) {
            return localVarFp.fmsCustomersOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidActivateOptions: function (unid, options) {
            return localVarFp.fmsCustomersUnidActivateOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidAllowedSerialNumbersOptions: function (unid, options) {
            return localVarFp.fmsCustomersUnidAllowedSerialNumbersOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions: function (serialNumber, unid, options) {
            return localVarFp.fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions(serialNumber, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidInvoicesOptions: function (unid, options) {
            return localVarFp.fmsCustomersUnidInvoicesOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidOptions: function (unid, options) {
            return localVarFp.fmsCustomersUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidUsersOptions: function (unid, options) {
            return localVarFp.fmsCustomersUnidUsersOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {string} userUnid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsCustomersUnidUsersUserUnidOptions: function (unid, userUnid, options) {
            return localVarFp.fmsCustomersUnidUsersUserUnidOptions(unid, userUnid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsElectricRateOptions: function (options) {
            return localVarFp.fmsElectricRateOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsElectricRateOptionsOptions: function (options) {
            return localVarFp.fmsElectricRateOptionsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsOptions: function (options) {
            return localVarFp.fmsFleetsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidAlertsOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidAlertsOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidControlValuesOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidControlValuesOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCsvReportsIdOptions: function (id, unid, options) {
            return localVarFp.fmsFleetsUnidCsvReportsIdOptions(id, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCsvReportsOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidCsvReportsOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidCurrentLimitOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidCurrentLimitOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidElectricRateOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidElectricRateOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidEnergyUsageOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidEnergyUsageOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidLimitsOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidLimitsOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidReportsIdOptions: function (id, unid, options) {
            return localVarFp.fmsFleetsUnidReportsIdOptions(id, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidReportsOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidReportsOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidScheduleOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidScheduleOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} jobId
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidStatusChecksJobIdOptions: function (jobId, unid, options) {
            return localVarFp.fmsFleetsUnidStatusChecksJobIdOptions(jobId, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidStatusChecksOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidStatusChecksOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidTopEnergyUsersOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidTopEnergyUsersOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidTopUsersOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidTopUsersOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsBulkOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidUnitsBulkOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsOptions: function (unid, options) {
            return localVarFp.fmsFleetsUnidUnitsOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsFleetsUnidUnitsSerialNumberOptions: function (serialNumber, unid, options) {
            return localVarFp.fmsFleetsUnidUnitsSerialNumberOptions(serialNumber, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsForgotPasswordOptions: function (options) {
            return localVarFp.fmsForgotPasswordOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsGradientAdminsOptions: function (options) {
            return localVarFp.fmsGradientAdminsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsInvoicesOptions: function (options) {
            return localVarFp.fmsInvoicesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsLoginOptions: function (options) {
            return localVarFp.fmsLoginOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsLogoutOptions: function (options) {
            return localVarFp.fmsLogoutOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsOptions: function (options) {
            return localVarFp.fmsNotificationsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsUnidOptions: function (unid, options) {
            return localVarFp.fmsNotificationsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsNotificationsUnidViewOptions: function (unid, options) {
            return localVarFp.fmsNotificationsUnidViewOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesOptions: function (options) {
            return localVarFp.fmsPropertiesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidBuildingsBuildingUnidOptions: function (buildingUnid, unid, options) {
            return localVarFp.fmsPropertiesUnidBuildingsBuildingUnidOptions(buildingUnid, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidBuildingsOptions: function (unid, options) {
            return localVarFp.fmsPropertiesUnidBuildingsOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsPropertiesUnidOptions: function (unid, options) {
            return localVarFp.fmsPropertiesUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsSyncJobsUnidOptions: function (unid, options) {
            return localVarFp.fmsSyncJobsUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnassociatedUnitsOptions: function (options) {
            return localVarFp.fmsUnassociatedUnitsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnassociatedUnitsSerialNumberOptions: function (serialNumber, options) {
            return localVarFp.fmsUnassociatedUnitsSerialNumberOptions(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUnitsOptions: function (options) {
            return localVarFp.fmsUnitsOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersMeOptions: function (options) {
            return localVarFp.fmsUsersMeOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersOptions: function (options) {
            return localVarFp.fmsUsersOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmsUsersUnidOptions: function (unid, options) {
            return localVarFp.fmsUsersUnidOptions(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailReportStatus: function (id, options) {
            return localVarFp.getAuditTrailReportStatus(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuilding: function (buildingUnid, unid, options) {
            return localVarFp.getBuilding(buildingUnid, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElectricRateOptions: function (options) {
            return localVarFp.getElectricRateOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSCustomer: function (unid, options) {
            return localVarFp.getFMSCustomer(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSCustomerUser: function (unid, options) {
            return localVarFp.getFMSCustomerUser(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFMSNotification: function (unid, options) {
            return localVarFp.getFMSNotification(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleet: function (unid, options) {
            return localVarFp.getFleet(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetCSVReportStatus: function (id, unid, options) {
            return localVarFp.getFleetCSVReportStatus(id, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetControlValues: function (unid, options) {
            return localVarFp.getFleetControlValues(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetCurrentLimit: function (unid, options) {
            return localVarFp.getFleetCurrentLimit(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetElectricRate: function (unid, options) {
            return localVarFp.getFleetElectricRate(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetEnergyUsage: function (unid, options) {
            return localVarFp.getFleetEnergyUsage(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLimits: function (unid, options) {
            return localVarFp.getFleetLimits(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetReportStatus: function (id, unid, options) {
            return localVarFp.getFleetReportStatus(id, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetSchedule: function (unid, options) {
            return localVarFp.getFleetSchedule(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} jobId
         * @param {string} unid
         * @param {Array<string>} [watchedSerialNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetStatusCheckJob: function (jobId, unid, watchedSerialNumbers, options) {
            return localVarFp.getFleetStatusCheckJob(jobId, unid, watchedSerialNumbers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetTopUsers: function (unid, options) {
            return localVarFp.getFleetTopUsers(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetUnit: function (serialNumber, unid, options) {
            return localVarFp.getFleetUnit(serialNumber, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: function (unid, options) {
            return localVarFp.getProperty(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassociatedUnit: function (serialNumber, options) {
            return localVarFp.getUnassociatedUnit(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFleetUnit: function (serialNumber, unid, options) {
            return localVarFp.removeFleetUnit(serialNumber, unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFleetStatusCheck: function (unid, options) {
            return localVarFp.startFleetStatusCheck(unid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} buildingUnid
         * @param {string} unid
         * @param {UpdateBuildingInput} [updateBuildingInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuilding: function (buildingUnid, unid, updateBuildingInput, options) {
            return localVarFp.updateBuilding(buildingUnid, unid, updateBuildingInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateCustomerElectricRateInput} [updateCustomerElectricRateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerElectricRate: function (updateCustomerElectricRateInput, options) {
            return localVarFp.updateCustomerElectricRate(updateCustomerElectricRateInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSCustomerInput} [updateFMSCustomerInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSCustomer: function (unid, updateFMSCustomerInput, options) {
            return localVarFp.updateFMSCustomer(unid, updateFMSCustomerInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSCustomerUserInput} [updateFMSCustomerUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSCustomerUser: function (unid, updateFMSCustomerUserInput, options) {
            return localVarFp.updateFMSCustomerUser(unid, updateFMSCustomerUserInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFMSNotificationInput} [updateFMSNotificationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFMSNotification: function (unid, updateFMSNotificationInput, options) {
            return localVarFp.updateFMSNotification(unid, updateFMSNotificationInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetInput} [updateFleetInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleet: function (unid, updateFleetInput, options) {
            return localVarFp.updateFleet(unid, updateFleetInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetControlValuesInput} [updateFleetControlValuesInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetControlValues: function (unid, updateFleetControlValuesInput, options) {
            return localVarFp.updateFleetControlValues(unid, updateFleetControlValuesInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetCurrentLimitInput} [updateFleetCurrentLimitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetCurrentLimit: function (unid, updateFleetCurrentLimitInput, options) {
            return localVarFp.updateFleetCurrentLimit(unid, updateFleetCurrentLimitInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetElectricRateInput} [updateFleetElectricRateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetElectricRate: function (unid, updateFleetElectricRateInput, options) {
            return localVarFp.updateFleetElectricRate(unid, updateFleetElectricRateInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetLimitsInput} [updateFleetLimitsInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetLimits: function (unid, updateFleetLimitsInput, options) {
            return localVarFp.updateFleetLimits(unid, updateFleetLimitsInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdateFleetScheduleInput} [updateFleetScheduleInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetSchedule: function (unid, updateFleetScheduleInput, options) {
            return localVarFp.updateFleetSchedule(unid, updateFleetScheduleInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {string} unid
         * @param {UpdateFleetUnitInput} [updateFleetUnitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFleetUnit: function (serialNumber, unid, updateFleetUnitInput, options) {
            return localVarFp.updateFleetUnit(serialNumber, unid, updateFleetUnitInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {UpdatePropertyInput} [updatePropertyInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProperty: function (unid, updatePropertyInput, options) {
            return localVarFp.updateProperty(unid, updatePropertyInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber
         * @param {UpdateUnassociatedUnitInput} [updateUnassociatedUnitInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnassociatedUnit: function (serialNumber, updateUnassociatedUnitInput, options) {
            return localVarFp.updateUnassociatedUnit(serialNumber, updateUnassociatedUnitInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} unid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFMSNotification: function (unid, options) {
            return localVarFp.viewFMSNotification(unid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FleetManagementSystemApiFactory = FleetManagementSystemApiFactory;
/**
 * FleetManagementSystemApi - object-oriented interface
 */
var FleetManagementSystemApi = /** @class */ (function (_super) {
    __extends(FleetManagementSystemApi, _super);
    function FleetManagementSystemApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} unid
     * @param {AddAllowedSerialNumbersInput} [addAllowedSerialNumbersInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.addAllowedSerialNumbers = function (unid, addAllowedSerialNumbersInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).addAllowedSerialNumbers(unid, addAllowedSerialNumbersInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {AddUnitToFleetInput} [addUnitToFleetInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.addUnitToFleet = function (unid, addUnitToFleetInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).addUnitToFleet(unid, addUnitToFleetInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminActivateFMSCustomer = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminActivateFMSCustomer(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {AdminCreateFMSCustomerUserInput} [adminCreateFMSCustomerUserInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminCreateFMSCustomerUser = function (unid, adminCreateFMSCustomerUserInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminCreateFMSCustomerUser(unid, adminCreateFMSCustomerUserInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {string} userUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminDeleteCustomerUser = function (unid, userUnid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminDeleteCustomerUser(unid, userUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {boolean | null} [isOverdue]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminFetchPageOfCustomerLicenseInvoices = function (unid, pageNumber, isOverdue, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminFetchPageOfCustomerLicenseInvoices(unid, pageNumber, isOverdue, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminFetchPageOfCustomerUsers = function (unid, pageNumber, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminFetchPageOfCustomerUsers(unid, pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {string} userUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminGetCustomerUser = function (unid, userUnid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminGetCustomerUser(unid, userUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.adminRemoveAllowedSerialNumber = function (serialNumber, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).adminRemoveAllowedSerialNumber(serialNumber, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {BulkAddUnitsToFleetInput} [bulkAddUnitsToFleetInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.bulkAddUnitsToFleet = function (unid, bulkAddUnitsToFleetInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).bulkAddUnitsToFleet(unid, bulkAddUnitsToFleetInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateAuditTrailReportInput} [createAuditTrailReportInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createAuditTrailReport = function (createAuditTrailReportInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createAuditTrailReport(createAuditTrailReportInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {CreateBuildingInput} [createBuildingInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createBuilding = function (unid, createBuildingInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createBuilding(unid, createBuildingInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateFMSCustomerInput} [createFMSCustomerInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createFMSCustomer = function (createFMSCustomerInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createFMSCustomer(createFMSCustomerInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateFMSCustomerUserInput} [createFMSCustomerUserInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createFMSCustomerUser = function (createFMSCustomerUserInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createFMSCustomerUser(createFMSCustomerUserInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateFMSNotificationInput} [createFMSNotificationInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createFMSNotification = function (createFMSNotificationInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createFMSNotification(createFMSNotificationInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateFleetInput} [createFleetInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createFleet = function (createFleetInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createFleet(createFleetInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {CreateFleetCSVReportInput} [createFleetCSVReportInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createFleetCSVReport = function (unid, createFleetCSVReportInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createFleetCSVReport(unid, createFleetCSVReportInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {CreateFleetReportInput} [createFleetReportInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createFleetReport = function (unid, createFleetReportInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createFleetReport(unid, createFleetReportInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreatePropertyInput} [createPropertyInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.createProperty = function (createPropertyInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).createProperty(createPropertyInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {boolean | null} [isOverdue]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.customerUserFetchPageOfCustomerLicenseInvoices = function (pageNumber, isOverdue, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).customerUserFetchPageOfCustomerLicenseInvoices(pageNumber, isOverdue, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} buildingUnid
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteBuilding = function (buildingUnid, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteBuilding(buildingUnid, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteCustomerElectricRate = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteCustomerElectricRate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteFMSCustomer = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteFMSCustomer(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteFMSCustomerUser = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteFMSCustomerUser(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteFMSNotification = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteFMSNotification(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteFleet = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteFleet(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteFleetSchedule = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteFleetSchedule(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.deleteProperty = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).deleteProperty(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FMSCreateGradientAdminInput} [fMSCreateGradientAdminInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSCreateGradientAdmin = function (fMSCreateGradientAdminInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSCreateGradientAdmin(fMSCreateGradientAdminInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FMSForgotPasswordInput} [fMSForgotPasswordInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSForgotPassword = function (fMSForgotPasswordInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSForgotPassword(fMSForgotPasswordInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSGetSelf = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSGetSelf(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSGetSyncJobStatus = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSGetSyncJobStatus(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FMSLoginInput} [fMSLoginInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSLogin = function (fMSLoginInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSLogin(fMSLoginInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSLogout = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSLogout(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FMSUpdateSelfInput} [fMSUpdateSelfInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fMSUpdateSelf = function (fMSUpdateSelfInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fMSUpdateSelf(fMSUpdateSelfInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {string | null} [serialNumberFragment] If provided, only serial numbers containing this fragment will be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfAllowedSerialNumbers = function (unid, pageNumber, pageSize, serialNumberFragment, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfAllowedSerialNumbers(unid, pageNumber, pageSize, serialNumberFragment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
     * @param {string | null} [belongsToFleet] If provided, only units that belong to a fleet or do not belong to a fleet will be returned
     * @param {number | null} [pageSize]
     * @param {string | null} [search]
     * @param {string | null} [sortBy]
     * @param {string | null} [sortDirection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfCustomerUnits = function (pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfCustomerUnits(pageNumber, activated, belongsToFleet, pageSize, search, sortBy, sortDirection, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {string | null} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFMSCustomerUsers = function (pageNumber, pageSize, search, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFMSCustomerUsers(pageNumber, pageSize, search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFMSCustomers = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFMSCustomers(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFMSNotifications = function (pageNumber, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFMSNotifications(pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {string | null} [search]
     * @param {string | null} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFleetAlerts = function (unid, pageNumber, pageSize, search, status, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFleetAlerts(unid, pageNumber, pageSize, search, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFleetStatusCheckJobs = function (unid, pageNumber, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFleetStatusCheckJobs(unid, pageNumber, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {FetchPageOfFleetTopUsersTimePeriodEnum} timePeriod
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFleetTopUsers = function (unid, pageNumber, timePeriod, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFleetTopUsers(unid, pageNumber, timePeriod, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {number} pageNumber
     * @param {string | null} [connected]
     * @param {number | null} [pageSize]
     * @param {string | null} [running]
     * @param {string | null} [search]
     * @param {string | null} [sortBy]
     * @param {string | null} [sortDirection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFleetUnits = function (unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFleetUnits(unid, pageNumber, connected, pageSize, running, search, sortBy, sortDirection, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {number | null} [pageSize]
     * @param {string | null} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfFleets = function (pageNumber, pageSize, search, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfFleets(pageNumber, pageSize, search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {string | null} [nameFragment]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfProperties = function (pageNumber, nameFragment, pageSize, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfProperties(pageNumber, nameFragment, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} pageNumber
     * @param {string | null} [activated] If provided, only serial numbers that are activated or not activated will be returned
     * @param {number | null} [pageSize]
     * @param {string | null} [search]
     * @param {string | null} [sortBy]
     * @param {string | null} [sortDirection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fetchPageOfUnassociatedUnits = function (pageNumber, activated, pageSize, search, sortBy, sortDirection, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fetchPageOfUnassociatedUnits(pageNumber, activated, pageSize, search, sortBy, sortDirection, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersAuditTrailReportsIdOptions = function (id, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersAuditTrailReportsIdOptions(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersAuditTrailReportsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersAuditTrailReportsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidActivateOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidActivateOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidAllowedSerialNumbersOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidAllowedSerialNumbersOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions = function (serialNumber, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidAllowedSerialNumbersSerialNumberOptions(serialNumber, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidInvoicesOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidInvoicesOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidUsersOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidUsersOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {string} userUnid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsCustomersUnidUsersUserUnidOptions = function (unid, userUnid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsCustomersUnidUsersUserUnidOptions(unid, userUnid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsElectricRateOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsElectricRateOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsElectricRateOptionsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsElectricRateOptionsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidAlertsOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidAlertsOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidControlValuesOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidControlValuesOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidCsvReportsIdOptions = function (id, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidCsvReportsIdOptions(id, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidCsvReportsOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidCsvReportsOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidCurrentLimitOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidCurrentLimitOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidElectricRateOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidElectricRateOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidEnergyUsageOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidEnergyUsageOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidLimitsOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidLimitsOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidReportsIdOptions = function (id, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidReportsIdOptions(id, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidReportsOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidReportsOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidScheduleOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidScheduleOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} jobId
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidStatusChecksJobIdOptions = function (jobId, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidStatusChecksJobIdOptions(jobId, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidStatusChecksOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidStatusChecksOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidTopEnergyUsersOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidTopEnergyUsersOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidTopUsersOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidTopUsersOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidUnitsBulkOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidUnitsBulkOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidUnitsOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidUnitsOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsFleetsUnidUnitsSerialNumberOptions = function (serialNumber, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsFleetsUnidUnitsSerialNumberOptions(serialNumber, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsForgotPasswordOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsForgotPasswordOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsGradientAdminsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsGradientAdminsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsInvoicesOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsInvoicesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsLoginOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsLoginOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsLogoutOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsLogoutOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsNotificationsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsNotificationsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsNotificationsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsNotificationsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsNotificationsUnidViewOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsNotificationsUnidViewOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsPropertiesOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsPropertiesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} buildingUnid
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsPropertiesUnidBuildingsBuildingUnidOptions = function (buildingUnid, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsPropertiesUnidBuildingsBuildingUnidOptions(buildingUnid, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsPropertiesUnidBuildingsOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsPropertiesUnidBuildingsOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsPropertiesUnidOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsPropertiesUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsSyncJobsUnidOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsSyncJobsUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsUnassociatedUnitsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsUnassociatedUnitsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsUnassociatedUnitsSerialNumberOptions = function (serialNumber, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsUnassociatedUnitsSerialNumberOptions(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsUnitsOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsUnitsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsUsersMeOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsUsersMeOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsUsersOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsUsersOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.fmsUsersUnidOptions = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).fmsUsersUnidOptions(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getAuditTrailReportStatus = function (id, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getAuditTrailReportStatus(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} buildingUnid
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getBuilding = function (buildingUnid, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getBuilding(buildingUnid, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getElectricRateOptions = function (options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getElectricRateOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFMSCustomer = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFMSCustomer(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFMSCustomerUser = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFMSCustomerUser(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFMSNotification = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFMSNotification(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleet = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleet(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetCSVReportStatus = function (id, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetCSVReportStatus(id, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetControlValues = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetControlValues(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetCurrentLimit = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetCurrentLimit(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetElectricRate = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetElectricRate(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetEnergyUsage = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetEnergyUsage(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetLimits = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetLimits(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetReportStatus = function (id, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetReportStatus(id, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetSchedule = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetSchedule(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} jobId
     * @param {string} unid
     * @param {Array<string>} [watchedSerialNumbers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetStatusCheckJob = function (jobId, unid, watchedSerialNumbers, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetStatusCheckJob(jobId, unid, watchedSerialNumbers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetTopUsers = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetTopUsers(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getFleetUnit = function (serialNumber, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getFleetUnit(serialNumber, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getProperty = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getProperty(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.getUnassociatedUnit = function (serialNumber, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).getUnassociatedUnit(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.removeFleetUnit = function (serialNumber, unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).removeFleetUnit(serialNumber, unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.startFleetStatusCheck = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).startFleetStatusCheck(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} buildingUnid
     * @param {string} unid
     * @param {UpdateBuildingInput} [updateBuildingInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateBuilding = function (buildingUnid, unid, updateBuildingInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateBuilding(buildingUnid, unid, updateBuildingInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateCustomerElectricRateInput} [updateCustomerElectricRateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateCustomerElectricRate = function (updateCustomerElectricRateInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateCustomerElectricRate(updateCustomerElectricRateInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFMSCustomerInput} [updateFMSCustomerInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFMSCustomer = function (unid, updateFMSCustomerInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFMSCustomer(unid, updateFMSCustomerInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFMSCustomerUserInput} [updateFMSCustomerUserInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFMSCustomerUser = function (unid, updateFMSCustomerUserInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFMSCustomerUser(unid, updateFMSCustomerUserInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFMSNotificationInput} [updateFMSNotificationInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFMSNotification = function (unid, updateFMSNotificationInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFMSNotification(unid, updateFMSNotificationInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFleetInput} [updateFleetInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleet = function (unid, updateFleetInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleet(unid, updateFleetInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFleetControlValuesInput} [updateFleetControlValuesInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleetControlValues = function (unid, updateFleetControlValuesInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleetControlValues(unid, updateFleetControlValuesInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFleetCurrentLimitInput} [updateFleetCurrentLimitInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleetCurrentLimit = function (unid, updateFleetCurrentLimitInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleetCurrentLimit(unid, updateFleetCurrentLimitInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFleetElectricRateInput} [updateFleetElectricRateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleetElectricRate = function (unid, updateFleetElectricRateInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleetElectricRate(unid, updateFleetElectricRateInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFleetLimitsInput} [updateFleetLimitsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleetLimits = function (unid, updateFleetLimitsInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleetLimits(unid, updateFleetLimitsInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdateFleetScheduleInput} [updateFleetScheduleInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleetSchedule = function (unid, updateFleetScheduleInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleetSchedule(unid, updateFleetScheduleInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {string} unid
     * @param {UpdateFleetUnitInput} [updateFleetUnitInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateFleetUnit = function (serialNumber, unid, updateFleetUnitInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateFleetUnit(serialNumber, unid, updateFleetUnitInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {UpdatePropertyInput} [updatePropertyInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateProperty = function (unid, updatePropertyInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateProperty(unid, updatePropertyInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber
     * @param {UpdateUnassociatedUnitInput} [updateUnassociatedUnitInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.updateUnassociatedUnit = function (serialNumber, updateUnassociatedUnitInput, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).updateUnassociatedUnit(serialNumber, updateUnassociatedUnitInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} unid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    FleetManagementSystemApi.prototype.viewFMSNotification = function (unid, options) {
        var _this = this;
        return exports.FleetManagementSystemApiFp(this.configuration).viewFMSNotification(unid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FleetManagementSystemApi;
}(base_1.BaseAPI));
exports.FleetManagementSystemApi = FleetManagementSystemApi;
exports.FetchPageOfFleetTopUsersTimePeriodEnum = {
    _24h: '24h',
    _7d: '7d',
    _30d: '30d',
};
/**
 * IOTEventRoutesApi - axios parameter creator
 */
var IOTEventRoutesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {ThingDeletedChangeInput} [thingDeletedChangeInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thingDeletedChange: function (confirmationToken, iotKey, thingDeletedChangeInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/iotevents/things";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (confirmationToken !== undefined) {
                        localVarQueryParameter['confirmationToken'] = confirmationToken;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (iotKey != null) {
                        localVarHeaderParameter['iotKey'] = String(iotKey);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(thingDeletedChangeInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.IOTEventRoutesApiAxiosParamCreator = IOTEventRoutesApiAxiosParamCreator;
/**
 * IOTEventRoutesApi - functional programming interface
 */
var IOTEventRoutesApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.IOTEventRoutesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {ThingDeletedChangeInput} [thingDeletedChangeInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thingDeletedChange: function (confirmationToken, iotKey, thingDeletedChangeInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.thingDeletedChange(confirmationToken, iotKey, thingDeletedChangeInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['IOTEventRoutesApi.thingDeletedChange']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.IOTEventRoutesApiFp = IOTEventRoutesApiFp;
/**
 * IOTEventRoutesApi - factory interface
 */
var IOTEventRoutesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.IOTEventRoutesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {ThingDeletedChangeInput} [thingDeletedChangeInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thingDeletedChange: function (confirmationToken, iotKey, thingDeletedChangeInput, options) {
            return localVarFp.thingDeletedChange(confirmationToken, iotKey, thingDeletedChangeInput, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IOTEventRoutesApiFactory = IOTEventRoutesApiFactory;
/**
 * IOTEventRoutesApi - object-oriented interface
 */
var IOTEventRoutesApi = /** @class */ (function (_super) {
    __extends(IOTEventRoutesApi, _super);
    function IOTEventRoutesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [confirmationToken]
     * @param {string} [iotKey]
     * @param {ThingDeletedChangeInput} [thingDeletedChangeInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    IOTEventRoutesApi.prototype.thingDeletedChange = function (confirmationToken, iotKey, thingDeletedChangeInput, options) {
        var _this = this;
        return exports.IOTEventRoutesApiFp(this.configuration).thingDeletedChange(confirmationToken, iotKey, thingDeletedChangeInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IOTEventRoutesApi;
}(base_1.BaseAPI));
exports.IOTEventRoutesApi = IOTEventRoutesApi;
/**
 * OptionsApi - axios parameter creator
 */
var OptionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceLocations: function (lang, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/options/locations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            if (lang !== undefined) {
                                localVarQueryParameter['lang'] = lang;
                            }
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OptionsApiAxiosParamCreator = OptionsApiAxiosParamCreator;
/**
 * OptionsApi - functional programming interface
 */
var OptionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.OptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceLocations: function (lang, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceLocations(lang, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OptionsApi.getDeviceLocations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OptionsApiFp = OptionsApiFp;
/**
 * OptionsApi - factory interface
 */
var OptionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.OptionsApiFp(configuration);
    return {
        /**
         *
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceLocations: function (lang, options) {
            return localVarFp.getDeviceLocations(lang, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OptionsApiFactory = OptionsApiFactory;
/**
 * OptionsApi - object-oriented interface
 */
var OptionsApi = /** @class */ (function (_super) {
    __extends(OptionsApi, _super);
    function OptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    OptionsApi.prototype.getDeviceLocations = function (lang, options) {
        var _this = this;
        return exports.OptionsApiFp(this.configuration).getDeviceLocations(lang, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OptionsApi;
}(base_1.BaseAPI));
exports.OptionsApi = OptionsApi;
/**
 * ThingGroupRoutesApi - axios parameter creator
 */
var ThingGroupRoutesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {ThingGroupMembershipChangeInput} [thingGroupMembershipChangeInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thingGroupMembershipChange: function (confirmationToken, iotKey, thingGroupMembershipChangeInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/thinggroups/membership";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (confirmationToken !== undefined) {
                        localVarQueryParameter['confirmationToken'] = confirmationToken;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (iotKey != null) {
                        localVarHeaderParameter['iotKey'] = String(iotKey);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(thingGroupMembershipChangeInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ThingGroupRoutesApiAxiosParamCreator = ThingGroupRoutesApiAxiosParamCreator;
/**
 * ThingGroupRoutesApi - functional programming interface
 */
var ThingGroupRoutesApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ThingGroupRoutesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {ThingGroupMembershipChangeInput} [thingGroupMembershipChangeInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thingGroupMembershipChange: function (confirmationToken, iotKey, thingGroupMembershipChangeInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.thingGroupMembershipChange(confirmationToken, iotKey, thingGroupMembershipChangeInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ThingGroupRoutesApi.thingGroupMembershipChange']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ThingGroupRoutesApiFp = ThingGroupRoutesApiFp;
/**
 * ThingGroupRoutesApi - factory interface
 */
var ThingGroupRoutesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ThingGroupRoutesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [confirmationToken]
         * @param {string} [iotKey]
         * @param {ThingGroupMembershipChangeInput} [thingGroupMembershipChangeInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thingGroupMembershipChange: function (confirmationToken, iotKey, thingGroupMembershipChangeInput, options) {
            return localVarFp.thingGroupMembershipChange(confirmationToken, iotKey, thingGroupMembershipChangeInput, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ThingGroupRoutesApiFactory = ThingGroupRoutesApiFactory;
/**
 * ThingGroupRoutesApi - object-oriented interface
 */
var ThingGroupRoutesApi = /** @class */ (function (_super) {
    __extends(ThingGroupRoutesApi, _super);
    function ThingGroupRoutesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [confirmationToken]
     * @param {string} [iotKey]
     * @param {ThingGroupMembershipChangeInput} [thingGroupMembershipChangeInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ThingGroupRoutesApi.prototype.thingGroupMembershipChange = function (confirmationToken, iotKey, thingGroupMembershipChangeInput, options) {
        var _this = this;
        return exports.ThingGroupRoutesApiFp(this.configuration).thingGroupMembershipChange(confirmationToken, iotKey, thingGroupMembershipChangeInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ThingGroupRoutesApi;
}(base_1.BaseAPI));
exports.ThingGroupRoutesApi = ThingGroupRoutesApi;
/**
 * UsersApi - axios parameter creator
 */
var UsersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} token
         * @param {AddDeviceToUserInput} [addDeviceToUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceToUser: function (token, addDeviceToUserInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('addDeviceToUser', 'token', token);
                            localVarPath = "/users/devices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addDeviceToUserInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {AddUserAppInput} [addUserAppInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserApp: function (token, addUserAppInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('addUserApp', 'token', token);
                            localVarPath = "/users/apps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addUserAppInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountDeletion: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    common_1.assertParamExists('completeAccountDeletion', 'token', token);
                    localVarPath = "/users/complete-account-deletion";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (token != null) {
                        localVarHeaderParameter['token'] = String(token);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {CreateFailedProvisioningSupportTicketInput} [createFailedProvisioningSupportTicketInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFailedProvisioningSupportTicket: function (token, createFailedProvisioningSupportTicketInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('createFailedProvisioningSupportTicket', 'token', token);
                            localVarPath = "/users/failed-provisioning-support-tickets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFailedProvisioningSupportTicketInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('deleteProfile', 'token', token);
                            localVarPath = "/users/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {EditProfileInput} [editProfileInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProfile: function (token, editProfileInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('editProfile', 'token', token);
                            localVarPath = "/users/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editProfileInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ForgotPasswordInput} [forgotPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users/old/forgotPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(forgotPasswordInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoCredentials: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('getCognitoCredentials', 'token', token);
                            localVarPath = "/users/cognito";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('getProfile', 'token', token);
                            localVarPath = "/users/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDevice: function (deviceUnid, token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceUnid' is not null or undefined
                            common_1.assertParamExists('getUserDevice', 'deviceUnid', deviceUnid);
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('getUserDevice', 'token', token);
                            localVarPath = "/users/devices/{deviceUnid}"
                                .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDevices: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('getUserDevices', 'token', token);
                            localVarPath = "/users/devices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {InitiateAccountDeletionInput} [initiateAccountDeletionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAccountDeletion: function (initiateAccountDeletionInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users/initiate-account-deletion";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(initiateAccountDeletionInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {LoginInput} [loginInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users/old/login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loginInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('logout', 'token', token);
                            localVarPath = "/users/logout";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [token]
         * @param {ResetPasswordInput} [resetPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (token, resetPasswordInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users/old/resetPassword";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarHeaderParameter['Accept'] = 'application/json';
                    if (token != null) {
                        localVarHeaderParameter['token'] = String(token);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(resetPasswordInput, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {SignUpInput} [signUpInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: function (signUpInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users/old/signup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(signUpInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkDeviceFromUser: function (deviceUnid, token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceUnid' is not null or undefined
                            common_1.assertParamExists('unlinkDeviceFromUser', 'deviceUnid', deviceUnid);
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('unlinkDeviceFromUser', 'token', token);
                            localVarPath = "/users/devices/{deviceUnid}"
                                .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} clientId
         * @param {string} token
         * @param {UpdateUserAppInput} [updateUserAppInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserApp: function (clientId, token, updateUserAppInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'clientId' is not null or undefined
                            common_1.assertParamExists('updateUserApp', 'clientId', clientId);
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('updateUserApp', 'token', token);
                            localVarPath = "/users/apps/{clientId}"
                                .replace('{clientId}', encodeURIComponent(String(clientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateUserAppInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {UpdateUserDeviceInput} [updateUserDeviceInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDevice: function (deviceUnid, token, updateUserDeviceInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceUnid' is not null or undefined
                            common_1.assertParamExists('updateUserDevice', 'deviceUnid', deviceUnid);
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('updateUserDevice', 'token', token);
                            localVarPath = "/users/devices/{deviceUnid}"
                                .replace('{deviceUnid}', encodeURIComponent(String(deviceUnid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateUserDeviceInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {UserAcceptDeviceInvitationInput} [userAcceptDeviceInvitationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAcceptDeviceInvitation: function (token, userAcceptDeviceInvitationInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('userAcceptDeviceInvitation', 'token', token);
                            localVarPath = "/users/invitations/device/accept";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userAcceptDeviceInvitationInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCompleteAccountDeletionOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users/complete-account-deletion";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInitiateAccountDeletionOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users/initiate-account-deletion";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersOldResetPasswordOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users/old/resetPassword";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Accept'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UsersApiAxiosParamCreator = UsersApiAxiosParamCreator;
/**
 * UsersApi - functional programming interface
 */
var UsersApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {AddDeviceToUserInput} [addDeviceToUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceToUser: function (token, addDeviceToUserInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addDeviceToUser(token, addDeviceToUserInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.addDeviceToUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {AddUserAppInput} [addUserAppInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserApp: function (token, addUserAppInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUserApp(token, addUserAppInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.addUserApp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountDeletion: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.completeAccountDeletion(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.completeAccountDeletion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {CreateFailedProvisioningSupportTicketInput} [createFailedProvisioningSupportTicketInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFailedProvisioningSupportTicket: function (token, createFailedProvisioningSupportTicketInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFailedProvisioningSupportTicket(token, createFailedProvisioningSupportTicketInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.createFailedProvisioningSupportTicket']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProfile(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.deleteProfile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {EditProfileInput} [editProfileInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProfile: function (token, editProfileInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.editProfile(token, editProfileInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.editProfile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {ForgotPasswordInput} [forgotPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.forgotPassword(forgotPasswordInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.forgotPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoCredentials: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCognitoCredentials(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.getCognitoCredentials']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProfile(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.getProfile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDevice: function (deviceUnid, token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserDevice(deviceUnid, token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.getUserDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDevices: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserDevices(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.getUserDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {InitiateAccountDeletionInput} [initiateAccountDeletionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAccountDeletion: function (initiateAccountDeletionInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.initiateAccountDeletion(initiateAccountDeletionInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.initiateAccountDeletion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginInput} [loginInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.login(loginInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.login']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logout(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.logout']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [token]
         * @param {ResetPasswordInput} [resetPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (token, resetPasswordInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPassword(token, resetPasswordInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.resetPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {SignUpInput} [signUpInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: function (signUpInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.signUp(signUpInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.signUp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkDeviceFromUser: function (deviceUnid, token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unlinkDeviceFromUser(deviceUnid, token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.unlinkDeviceFromUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} clientId
         * @param {string} token
         * @param {UpdateUserAppInput} [updateUserAppInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserApp: function (clientId, token, updateUserAppInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUserApp(clientId, token, updateUserAppInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.updateUserApp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {UpdateUserDeviceInput} [updateUserDeviceInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDevice: function (deviceUnid, token, updateUserDeviceInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUserDevice(deviceUnid, token, updateUserDeviceInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.updateUserDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {UserAcceptDeviceInvitationInput} [userAcceptDeviceInvitationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAcceptDeviceInvitation: function (token, userAcceptDeviceInvitationInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userAcceptDeviceInvitation(token, userAcceptDeviceInvitationInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.userAcceptDeviceInvitation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCompleteAccountDeletionOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersCompleteAccountDeletionOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.usersCompleteAccountDeletionOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInitiateAccountDeletionOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersInitiateAccountDeletionOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.usersInitiateAccountDeletionOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersOldResetPasswordOptions: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersOldResetPasswordOptions(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.usersOldResetPasswordOptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 */
var UsersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.UsersApiFp(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {AddDeviceToUserInput} [addDeviceToUserInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceToUser: function (token, addDeviceToUserInput, options) {
            return localVarFp.addDeviceToUser(token, addDeviceToUserInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {AddUserAppInput} [addUserAppInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserApp: function (token, addUserAppInput, options) {
            return localVarFp.addUserApp(token, addUserAppInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountDeletion: function (token, options) {
            return localVarFp.completeAccountDeletion(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {CreateFailedProvisioningSupportTicketInput} [createFailedProvisioningSupportTicketInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFailedProvisioningSupportTicket: function (token, createFailedProvisioningSupportTicketInput, options) {
            return localVarFp.createFailedProvisioningSupportTicket(token, createFailedProvisioningSupportTicketInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (token, options) {
            return localVarFp.deleteProfile(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {EditProfileInput} [editProfileInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProfile: function (token, editProfileInput, options) {
            return localVarFp.editProfile(token, editProfileInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ForgotPasswordInput} [forgotPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordInput, options) {
            return localVarFp.forgotPassword(forgotPasswordInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoCredentials: function (token, options) {
            return localVarFp.getCognitoCredentials(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: function (token, options) {
            return localVarFp.getProfile(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDevice: function (deviceUnid, token, options) {
            return localVarFp.getUserDevice(deviceUnid, token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDevices: function (token, options) {
            return localVarFp.getUserDevices(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {InitiateAccountDeletionInput} [initiateAccountDeletionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAccountDeletion: function (initiateAccountDeletionInput, options) {
            return localVarFp.initiateAccountDeletion(initiateAccountDeletionInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LoginInput} [loginInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginInput, options) {
            return localVarFp.login(loginInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (token, options) {
            return localVarFp.logout(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [token]
         * @param {ResetPasswordInput} [resetPasswordInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (token, resetPasswordInput, options) {
            return localVarFp.resetPassword(token, resetPasswordInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {SignUpInput} [signUpInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: function (signUpInput, options) {
            return localVarFp.signUp(signUpInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkDeviceFromUser: function (deviceUnid, token, options) {
            return localVarFp.unlinkDeviceFromUser(deviceUnid, token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} clientId
         * @param {string} token
         * @param {UpdateUserAppInput} [updateUserAppInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserApp: function (clientId, token, updateUserAppInput, options) {
            return localVarFp.updateUserApp(clientId, token, updateUserAppInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceUnid
         * @param {string} token
         * @param {UpdateUserDeviceInput} [updateUserDeviceInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDevice: function (deviceUnid, token, updateUserDeviceInput, options) {
            return localVarFp.updateUserDevice(deviceUnid, token, updateUserDeviceInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {UserAcceptDeviceInvitationInput} [userAcceptDeviceInvitationInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAcceptDeviceInvitation: function (token, userAcceptDeviceInvitationInput, options) {
            return localVarFp.userAcceptDeviceInvitation(token, userAcceptDeviceInvitationInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCompleteAccountDeletionOptions: function (options) {
            return localVarFp.usersCompleteAccountDeletionOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInitiateAccountDeletionOptions: function (options) {
            return localVarFp.usersInitiateAccountDeletionOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersOldResetPasswordOptions: function (options) {
            return localVarFp.usersOldResetPasswordOptions(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApi - object-oriented interface
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} token
     * @param {AddDeviceToUserInput} [addDeviceToUserInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.addDeviceToUser = function (token, addDeviceToUserInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).addDeviceToUser(token, addDeviceToUserInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {AddUserAppInput} [addUserAppInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.addUserApp = function (token, addUserAppInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).addUserApp(token, addUserAppInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.completeAccountDeletion = function (token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).completeAccountDeletion(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {CreateFailedProvisioningSupportTicketInput} [createFailedProvisioningSupportTicketInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.createFailedProvisioningSupportTicket = function (token, createFailedProvisioningSupportTicketInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).createFailedProvisioningSupportTicket(token, createFailedProvisioningSupportTicketInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.deleteProfile = function (token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).deleteProfile(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {EditProfileInput} [editProfileInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.editProfile = function (token, editProfileInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).editProfile(token, editProfileInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ForgotPasswordInput} [forgotPasswordInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.forgotPassword = function (forgotPasswordInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).forgotPassword(forgotPasswordInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.getCognitoCredentials = function (token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).getCognitoCredentials(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.getProfile = function (token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).getProfile(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.getUserDevice = function (deviceUnid, token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).getUserDevice(deviceUnid, token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.getUserDevices = function (token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).getUserDevices(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {InitiateAccountDeletionInput} [initiateAccountDeletionInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.initiateAccountDeletion = function (initiateAccountDeletionInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).initiateAccountDeletion(initiateAccountDeletionInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LoginInput} [loginInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.login = function (loginInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).login(loginInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.logout = function (token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).logout(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [token]
     * @param {ResetPasswordInput} [resetPasswordInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.resetPassword = function (token, resetPasswordInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).resetPassword(token, resetPasswordInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {SignUpInput} [signUpInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.signUp = function (signUpInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).signUp(signUpInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.unlinkDeviceFromUser = function (deviceUnid, token, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).unlinkDeviceFromUser(deviceUnid, token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} clientId
     * @param {string} token
     * @param {UpdateUserAppInput} [updateUserAppInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.updateUserApp = function (clientId, token, updateUserAppInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).updateUserApp(clientId, token, updateUserAppInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceUnid
     * @param {string} token
     * @param {UpdateUserDeviceInput} [updateUserDeviceInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.updateUserDevice = function (deviceUnid, token, updateUserDeviceInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).updateUserDevice(deviceUnid, token, updateUserDeviceInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {UserAcceptDeviceInvitationInput} [userAcceptDeviceInvitationInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.userAcceptDeviceInvitation = function (token, userAcceptDeviceInvitationInput, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).userAcceptDeviceInvitation(token, userAcceptDeviceInvitationInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.usersCompleteAccountDeletionOptions = function (options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).usersCompleteAccountDeletionOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.usersInitiateAccountDeletionOptions = function (options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).usersInitiateAccountDeletionOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    UsersApi.prototype.usersOldResetPasswordOptions = function (options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).usersOldResetPasswordOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersApi;
}(base_1.BaseAPI));
exports.UsersApi = UsersApi;
/**
 * VersionApi - axios parameter creator
 */
var VersionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} token
         * @param {CheckDeviceOtaStatusInput} [checkDeviceOtaStatusInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDeviceOtaStatus: function (token, checkDeviceOtaStatusInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            common_1.assertParamExists('checkDeviceOtaStatus', 'token', token);
                            localVarPath = "/version/ota-status";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            if (token != null) {
                                localVarHeaderParameter['token'] = String(token);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(checkDeviceOtaStatusInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} buildVersion this will be something like 2020102701
         * @param {string} platform this will be: Android or iOS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionCheck: function (buildVersion, platform, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'buildVersion' is not null or undefined
                            common_1.assertParamExists('getVersionCheck', 'buildVersion', buildVersion);
                            // verify required parameter 'platform' is not null or undefined
                            common_1.assertParamExists('getVersionCheck', 'platform', platform);
                            localVarPath = "/version/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication api_key required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)];
                        case 1:
                            // authentication api_key required
                            _a.sent();
                            if (buildVersion !== undefined) {
                                localVarQueryParameter['buildVersion'] = buildVersion;
                            }
                            if (platform !== undefined) {
                                localVarQueryParameter['platform'] = platform;
                            }
                            localVarHeaderParameter['Accept'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VersionApiAxiosParamCreator = VersionApiAxiosParamCreator;
/**
 * VersionApi - functional programming interface
 */
var VersionApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.VersionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {CheckDeviceOtaStatusInput} [checkDeviceOtaStatusInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDeviceOtaStatus: function (token, checkDeviceOtaStatusInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkDeviceOtaStatus(token, checkDeviceOtaStatusInput, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VersionApi.checkDeviceOtaStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} buildVersion this will be something like 2020102701
         * @param {string} platform this will be: Android or iOS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionCheck: function (buildVersion, platform, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVersionCheck(buildVersion, platform, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['VersionApi.getVersionCheck']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.VersionApiFp = VersionApiFp;
/**
 * VersionApi - factory interface
 */
var VersionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.VersionApiFp(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {CheckDeviceOtaStatusInput} [checkDeviceOtaStatusInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDeviceOtaStatus: function (token, checkDeviceOtaStatusInput, options) {
            return localVarFp.checkDeviceOtaStatus(token, checkDeviceOtaStatusInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} buildVersion this will be something like 2020102701
         * @param {string} platform this will be: Android or iOS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionCheck: function (buildVersion, platform, options) {
            return localVarFp.getVersionCheck(buildVersion, platform, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VersionApiFactory = VersionApiFactory;
/**
 * VersionApi - object-oriented interface
 */
var VersionApi = /** @class */ (function (_super) {
    __extends(VersionApi, _super);
    function VersionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} token
     * @param {CheckDeviceOtaStatusInput} [checkDeviceOtaStatusInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    VersionApi.prototype.checkDeviceOtaStatus = function (token, checkDeviceOtaStatusInput, options) {
        var _this = this;
        return exports.VersionApiFp(this.configuration).checkDeviceOtaStatus(token, checkDeviceOtaStatusInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} buildVersion this will be something like 2020102701
     * @param {string} platform this will be: Android or iOS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    VersionApi.prototype.getVersionCheck = function (buildVersion, platform, options) {
        var _this = this;
        return exports.VersionApiFp(this.configuration).getVersionCheck(buildVersion, platform, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VersionApi;
}(base_1.BaseAPI));
exports.VersionApi = VersionApi;
//# sourceMappingURL=api.js.map